import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ImageSources, LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ImproveService } from 'src/app/appServices/ImproveService/improve.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { AxisLabelContentArgs, ChartComponent, LegendLabelsContentArgs, LineStyle, SeriesLabels, SeriesLabelsContentArgs, SeriesLabelsVisualArgs, ValueAxisLabels } from '@progress/kendo-angular-charts';
import { selectQuarterOptions, selectReportTypeOptionsImprove, selectedFacilityOptionsImprove, spokeSiteOpions } from 'src/app/appWeb/shared/shared';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
const htmlToPdfmake = require("html-to-pdfmake");
const domtoimage = require('dom-to-image');
const html2pdf = require('html2pdf.js');
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements OnInit {
  @ViewChild("htmlData1") htmlData1!: ChartComponent
  public lineChartPlugins = [ChartDataLabels];
  @ViewChild('htmlData') htmlData: any = ElementRef;
  // @ViewChild('editor') editor: any = ElementRef;
  @ViewChild('dd') dd: any = ElementRef;
  @ViewChild('dt') dt: Table | undefined;
  editorr = ClassicEditor;

  src: any = ImageSources.ImproveTeleLogo;
  public style: LineStyle = "smooth";
  take: any = 5;
  skip: any = 0;
  isCompare: boolean = false;
  dispalyBool: boolean = false;
  displayModal: boolean = false;
  ReportPageLoader: any = { 'value': false };

  Ten_Min_or_Less_Activation_EMS_PV_Chart_Data: any;


  datePipe = new DatePipe('en-US');
  selectedFacilityOptions = selectedFacilityOptionsImprove;
  facility: any = '';
  SelectListFilter: any = [];
  SelectFacilityData: any = [];
  SelectSystemData: any = [];
  SelectRegionData: any = [];
  selectFacilityPIOptions: any;
  selectedFilterType: any;
  SelectedReportType: any;
  selectActiveOptions: any = [];
  active = '';
  pre_ArrivalBool: boolean = false;
  preArivalOptions: any = [];
  pre_arival: any = '';
  workFlowRapidTypeBool: boolean = false;
  workFlow_typeOptions: any = [];
  work_flow_rapid: any = '';
  workFlowPiTrendTypeBool: boolean = false;
  selectWorkFlowTypeOptions: any = [];
  work_flow_piTrend: any = '';
  // spokeSiteOpions: any = [];
  spokeSite: any = '';
  reportTypeBool: boolean = false;
  selectReportTypeOptions = selectReportTypeOptionsImprove;
  reportType = '';
  fromDaysToDaysBool: boolean = false;
  Month: any = '';
  toMonth: any = '';
  YearQuarter: any = '';
  quarterYearBool: boolean = false;
  monthBool: boolean = false;
  selectWeekBool: boolean = false;
  selctReportOption: any;
  fromDays: any = '';
  toDays: any = '';
  week: any = '';
  event: any = '';
  FilterList: any;
  ByFacilityParticipatesPIReporting: any = [];
  selectedFacilitybtnBool: boolean = true;
  pageNumber = 1;
  sortOrder = 'Asc';
  sortCol = '';
  filterVal = '';
  loading: any = [];
  FilterDashboardImproveList: any = [];
  FilterDashboardImproveSelectedMonthList: any = [];
  FilterDashboardImproveListReplica: any = [];
  flag: any;
  chartBool: boolean = false;
  chartsTitle: any;
  cols: any;
  dashboardImproveData: any;
  System: any = null;
  Regional: any = null;
  States: any = null;
  QPS: any = null;
  ByPIFacility: any;
  selectedOptionText: string = '';
  headingSummaryOportunity: string = '';
  SelecedMonth: any;
  basedOnMonth: any;
  isShow: boolean = false;
  noRecordFoundDataBool: boolean = false;
  getRAPIDNotificationValuesList: any;
  activationTimeListQualifyCountEMS: number = 0;
  activationTimeListQualifyCountTriage: number = 0;
  assessmentTimeListQualifyCountEMS: number = 0;
  assessmentTimeListQualifyCountTriage: number = 0;
  assessmentTimeListQualifyCountInpatient: number = 0;
  assessmentTimeListQualifyCountEDOnset: number = 0;
  thrombolyticAdministrationTimeListQualifyCountEMS: number = 0;
  thrombolyticAdministrationTimeListQualifyCountTriage: number = 0;
  thrombolyticAdministrationTimeListQualifyCountInpatient: number = 0;
  thrombolyticAdministrationTimeListQualifyCountEDOnset: number = 0;
  thrombolyticDecisionTimeListQualifyCountEMS: number = 0;
  thrombolyticDecisionTimeListQualifyCountTriage: number = 0;
  thrombolyticDecisionTimeListQualifyCountInpatient: number = 0;
  thrombolyticDecisionTimeListQualifyCountEDOnset: number = 0;
  FilterDashboardImproveComulativeDataList: any = [];
  totalFacilityComulativeDataRecord: any;
  cumulativeYear: any = '';
  pastcumulativeYear: number = 0;
  FilterDashboardImproveComulativePastYearDataList: any;
  totalFacilityComulativePastYearDataRecord: any;
  qti_accomplishments_improvements: any = '';
  for_compare_textarea_data_on_save: any;
  qti_opportunities_pi_projects: any = '';
  qti_case_key: string = '';
  qti_Id: number = 0;
  selected_Month_Of_Year: any;
  improveSearchLoader: boolean = false;
  improveSaveLoader: boolean = false;
  showProgressSpinner: boolean = false;
  showsharedProgressSpinner: boolean = false;
  sharebtnLoader: boolean = false;
  roleAccessResult: any = [];
  isAccessReadWrite!: boolean;
  generateTemplatebool: boolean = false;
  improveAData: any = [];
  improveNData: any;
  improveAAData: any;
  improveATData: any;
  improveTAMHATS: any;
  improveAHAAHASFL: any;
  improveAHAAHASFL2: any;
  activationToNeedleArray: any;
  WorkFlowTypePercentage: number = 0;

  // Improve Template variables
  improveTemplate: any = '';
  improveFacilityTable: any = '';
  improveFacilityGraphs: any = '';
  improveRapidiMO: any = '';
  improveSummaryFacility: any = '';

  improveFacilityData: any = {};
  allChartsData: any = [];

  chartDatasets: any = [];
  barChartDatasets: any = [];
  doortostarttitle: any;
  doortostarttitleMean: any;
  doortostarttitleMedian: any;
  doortostartmean: any;
  doortostartmedian: any;
  doortostartmeancal: any = [];
  doortostartmediancal: any = [];
  doortostartcatgory: any;
  doortostartMinDate!: number;
  doortostartMaxDate!: number;

  activationemsmeancal = [];
  activationemscatgory: any;
  activationPvCatgory: any;
  activationpvmeancal = [];


  ActivationtoAssessmenttitleMean: any;
  starttoresponsetitleMean: any;
  starttoresponsetitleMedian: any;
  starttoresponsetitle: any;
  starttoresponsemean: any;
  starttoresponsemeancal: any = [];
  starttoresponsecatgory: any;
  starttoresponsemedian: any;
  starttoresponsemediancal: any = [];
  starttoresponseMinDate!: number;
  starttoresponseMaxDate!: number;

  alteplaseadmintitle: any;
  alteplaseadminmean: any;
  alteplaseadminmeancal: any = [];
  alteplaseadmincatgory: any;


  doortoneedletitle: any;


  doortoneedlemean: any;
  doortoneedlemeancal: any = [];
  doortoneedlecatgory: any;
  doortoneedlemedian: any;
  doortoneedlemediancal: any = [];
  doortoneedleMinDate!: number;
  doortoneedleMaxDate!: number;

  activitationtoneedletitle: any;
  activitationtoneedlemean: any;
  activitationtoneedlemeancal: any = [];
  activitationtoneedlecatgory: any;
  activitationtoneedlemedian: any;
  activitationtoneedlemediancal: any = [];
  activitationtoneedleMinDate!: number;
  activitationtoneedleMaxDate!: number;

  Activation_to_Needle_Average_Median_Chart_Data: any;
  Activation_to_Needle_Average_Median_Data_Options: any;
  Activation_to_Needle_Average_Median_Data: any;

  DTN30percentmean: any;
  DTN30percentmeancal: any = [];
  DTN30percentcatgory: any;
  DTN45percentcatgory: any;
  DTN60percentcatgory: any;

  DTN45percentmeancal: any = [];
  DTN60percentmeancal: any = [];

  ActivationtoAssessmenttitle: any;
  ActivationtoAssessmenttitleMedian: any;

  ActivationtoAssessmentmean: any;
  ActivationtoAssessmentmedian: any;
  ActivationtoAssessmentmeancal: any = [];
  ActivationtoAssessmentmediancal: any = [];
  ActivationtoAssessmentcatgory: any;
  ActivationtoAssessmentMinDate!: number;
  ActivationtoAssessmentMaxDate!: number;

  AssessmenttoThrombolytictitle: any;
  AssessmenttoThrombolytictitleMedian: any;

  AssessmenttoThrombolyticmedian: any;
  AssessmenttoThrombolyticmean: any;
  AssessmenttoThrombolyticmediancal: any = [];
  AssessmenttoThrombolyticmeancal: any = [];
  AssessmenttoThrombolyticcatgory: any;
  AssessmenttoThrombolyticMinDate!: number;
  AssessmenttoThrombolyticMaxDate!: number;

  ThrombolytictoThrombolyticadministrationtitleMean: any;
  ThrombolytictoThrombolyticadministrationtitleMedian: any;
  ThrombolytictoThrombolyticadministrationavg: any;
  ThrombolytictoThrombolyticadministrationmedian: any;
  ThrombolytictoThrombolyticadministrationmeancal: any = [];
  ThrombolytictoThrombolyticadministrationmediancal: any = [];
  ThrombolytictoThrombolyticadministrationcatgory: any;
  ThrombolytictoThrombolyticMinDate!: number;
  ThrombolytictoThrombolyticMaxDate!: number;

  doortonircallbacktitle: any;
  doortonircallbacktitleMedian: any;

  doortonircallbackmean: any;
  doortonircallbackmedian: any;
  doortonircallbackmeancal: any = [];
  doortonircallbackmediancal: any = [];
  doortonircallbackcatgory: any;
  shareImprove: any = [];
  allShareImprove: any = [];
  improveToEmail: any = [];
  totalRecords: number = 0;
  base64Image: any = [];
  isAccessRead!: boolean;
  displayBasic2: boolean = false;
  facilityMailData: any = [];
  sharedReportLoader: boolean = false;
  sharedWordLoader: boolean = false;
  sharedPdfLoader: boolean = false;
  generateTemplateLoader: boolean = false;
  getPdfLoader: boolean = false;
  noRecordFoundBool: boolean = false;
  longMonthOrYear: any = '';
  selectedOptionTextTemp: any;
  headingSummaryOportunityTemp: string = '';
  UId: any;
  RoleName: any;
  monthErrorBool!: boolean;
  filterTypeErrorBool!: boolean;
  reportTypeErrorBool!: boolean;
  yearErrorBool!: boolean;
  quarterErrorBool!: boolean;
  facilityErrorBool!: boolean;
  monthYear: any = '';
  reportPageBool: boolean = false;
  labelReportPage: any = '';
  chartFoundBool: boolean = false;
  isChangeTextBox: boolean = true;
  IsEmsOrInPatientBoolNewObj: any = [];
  public seriesLabels: SeriesLabels = {
    visible: true, // Note that visible defaults to false
    padding: 3,
    font: "bold 16px Arial, sans-serif",
  };
  public titleAlignment: any = {
    align: 'start'
  };
  public valueAxisLabels: ValueAxisLabels = {
    font: "bold 16px Arial, sans-serif",
    color: "#000000",
    format: 'N0'
  };
  public series: any = {
    color: '#ed2078',
    colorLabel: '#ed2078',
    font: "bold 16px Arial, sans-serif",
    padding: { bottom: 10 }
  };
  public seriesWidth: any = {
    font: "bold 10px Arial, sans-serif"
  };
  public seriesMedian: any = {
    color: '#36286b',
    colorLabel: '#36286b',
    font: "bold 16px Arial, sans-serif"
  };
  public seriesdtn60: any = {
    color: '#3B82F6',
    colorLabel: '#3B82F6',
    font: "bold 16px Arial, sans-serif"
  };




  screenWidth: number = 0;
  filterTypeBool: boolean = false;
  facilityQPSLbl: any;
  quarterBool: boolean = false;
  selectQuarterOptions = selectQuarterOptions;
  selectedQuarter: any = '';
  quarterYearForLabel: any;
  monthYearForLabel: any;
  monthYearForPreviousLabel: any;
  quarterYearForPreviousLabel: any;
  sMonth: any;
  private subscription: Subscription[] = [];
  activationEMSTotalRecords: number = 0;
  activationTriageTotalRecords: number = 0;
  activationEMSTimeList: any;
  activationTriageTimeList: any;
  activationEMSTimeCasesMean: number = 0;
  activationTriageTimeCasesMean: number = 0;
  activationEMSTimeCasesMedian: number = 0;
  activationTriageTimeCasesMedian: number = 0;
  activationTriageTimeCasesMaximum: number = 0;
  activationEMSTimeCasesMaximum: number = 0;
  assessmentEMSTimeList: any;
  assessmentEMSTotalRecords: number = 0;
  assessmentTriageTimeList: any;
  assessmentInpatientTimeList: any;
  assessmentEDOnsetTimeList: any;
  assessmentTriageTotalRecords: number = 0;
  assessmentInpatientTotalRecords: number = 0;
  assessmentEDOnsetTotalRecords: number = 0;
  assessmentEMSTimeCasesMedian: number = 0;
  assessmentEMSTimeCasesMaximum: number = 0;
  assessmentTriageTimeCasesMean: number = 0;
  assessmentInpatientTimeCasesMean: number = 0;
  assessmentEDOnsetTimeCasesMean: number = 0;
  assessmentTriageTimeCasesMedian: number = 0;
  timeCasesMedian: number = 0;
  assessmentInpatientTimeCasesMedian: number = 0;
  assessmentEDOnsetTimeCasesMedian: number = 0;
  assessmentTriageTimeCasesMaximum: number = 0;
  timeCasesMaximum: number = 0;
  assessmentInpatientTimeCasesMaximum: number = 0;
  assessmentEDOnsetTimeCasesMaximum: number = 0;
  assessmentEMSTimeCasesMean: number = 0;
  thrombolyticAdministrationEMSTimeCasesMean: number = 0;
  thrombolyticAdministrationEMSCasesMedian: number = 0;
  thrombolyticAdministrationEMSTimeCasesMaximum: number = 0;
  thrombolyticAdministrationTriageTimeCasesMean: number = 0;
  thrombolyticAdministrationInpatientTimeCasesMean: number = 0;
  thrombolyticAdministrationEDOnsetTimeCasesMean: number = 0;
  thrombolyticAdministrationTriageTimeCasesMedian: number = 0;
  thrombolyticAdministrationInpatientTimeCasesMedian: number = 0;
  thrombolyticAdministrationEDOnsetTimeCasesMedian: number = 0;
  thrombolyticAdministrationTriageTimeCasesMaximum: number = 0;
  thrombolyticAdministrationInpatientTimeCasesMaximum: number = 0;
  thrombolyticAdministrationEDOnsetTimeCasesMaximum: number = 0;
  thrombolyticAdministrationEMSTimeList: any;
  thrombolyticAdministrationEMSTotalRecords: any;
  thrombolyticAdministrationTriageTimeList: any;
  thrombolyticAdministrationInpatientTimeList: any;
  thrombolyticAdministrationEDOnsetTimeList: any;
  thrombolyticAdministrationTriageTotalRecords: any;
  thrombolyticAdministrationInpatientTotalRecords: any;
  thrombolyticAdministrationEDOnsetTotalRecords: any;
  thrombolyticDecisionEMSTimeList: any;
  thrombolyticDecisionEMSTotalRecords: any;
  thrombolyticDecisionTriageTotalRecords: any;
  thrombolyticDecisionEDOnsetTotalRecords: any;
  thrombolyticDecisionInpatientTotalRecords: any;
  thrombolyticDecisionTriageTimeList: any;
  thrombolyticDecisionInpatientTimeList: any;
  thrombolyticDecisionEDOnsetTimeList: any;
  thrombolyticDecisionEMSTimeCasesMean: number = 0;
  thrombolyticDecisionEMSTimeCasesMaximum: number = 0;
  thrombolyticDecisionTriageTimeCasesMaximum: number = 0;
  thrombolyticDecisionInpatientTimeCasesMaximum: number = 0;
  thrombolyticDecisionEDOnsetTimeCasesMaximum: number = 0;
  thrombolyticDecisionEMSTimeCasesMedian: number = 0;
  thrombolyticDecisionTriageTimeCasesMean: number = 0;
  thrombolyticDecisionInpatientTimeCasesMean: number = 0;
  thrombolyticDecisionEDOnsetTimeCasesMean: number = 0;
  thrombolyticDecisionTriageTimeCasesMedian: number = 0;
  thrombolyticDecisionInpatientTimeCasesMedian: number = 0;
  thrombolyticDecisionEDOnsetTimeCasesMedian: number = 0;
  selectedDateVolumetric: any = [];
  firstMonthDateVolumetric: any = [];
  selectedDateStrokeAlert: any = [];
  TotaAllCasesSelectedVolimatric: any;
  pieDataSelectedVolimatric: any;
  TotaAllSelectedDateStrokeAlert: any;
  pieDataSelectedDateStrokeAlert: any;
  minDate: any;
  maxDate: any;
  selectedDateVolumetricBool: boolean = false;
  selectedDateStrokeAlertBool: boolean = false;
  firstMonthDateVolumetricBool: boolean = false;
  minDateSelectedVolumetric: any = '';
  maxDateSelectedVolumetric: any = '';
  minDateFirstMonthVolumetric: any = '';
  maxDateFirstMonthVolumetric: any = '';
  minDateSelectedStrokeAlert: any = '';
  maxDateSelectedStrokeAlert: any = '';
  TotaAllFirstMonthDateVolumetric: any;
  activationTotalRecords: any = 0;
  assessmentTotalRecords: any = 0;
  thrombolyticDecisionTotalRecords: any = 0;
  thrombolyticAdministrationTotalRecords: any = 0;
  activationTgTotalRecords: any;
  assessmentTgTotalRecords: any;
  thrombolyticDecisionTgTotalRecords: any;
  assessmentTotalInpatientRecords: any;
  assessmentTotalTriageRecords: any;
  assessmentTotalEDOnsetRecords: any;
  thrombolyticAdministrationTgTotalRecords: any;
  thrombolyticAdministrationTotalInpatientRecords: any;
  thrombolyticAdministrationTotalTriageRecords: any;
  thrombolyticAdministrationTotalEDOnsetRecords: any;
  thrombolyticDecisionTotalInpatientRecords: any;
  thrombolyticDecisionTotalTriageRecords: any;
  thrombolyticDecisionEDOnsetRecords: any;
  roleForFacility: boolean = false;
  spokeSiteOpions = spokeSiteOpions;
  spokeSiteBool: boolean = false;
  stylesForData1: any = [];
  styleBool: boolean = false;
  stylesForData2: any = [];
  stylesForData3: any = [];
  stylesForCumlative1: any = [];
  stylesForCumlative2: any = [];
  boolForThrombolytic: boolean = false;
  administratedCheckData1Bool: boolean = false;
  administratedCheckData2Bool: boolean = false;
  administratedCheckData3Bool: boolean = false;
  finalTemplateData: any = '';
  qti_accomplishments_improvements_temp: any = '';
  qti_opportunities_pi_projects_temp: any = '';
  administratedCheckComulative1Bool: boolean = false;
  administratedCheckComulative2Bool: boolean = false;
  IsEmsOrInPatData1Bool: boolean = false;
  IsEmsOrInPatData2Bool: boolean = false;
  IsEmsOrInPatData3Bool: boolean = false;
  IsEmsOrInPatComulative1Bool: boolean = false;
  IsEmsOrInPatComulative2Bool: boolean = false;
  qti_data_by_month_of_year: any;
  qti_quarter_year: any;
  qti_quarter_number: any;
  qti_data: any;

  constructor(private analyzeService: AnalyzeService,
    private improveService: ImproveService,
    private helperService: HelperService,
    private toastrNotificaion: ToasterService,
    private messageService: MessageService,
    private accessControlService: AccessControlService,
    private authService: AuthService) { this.labelContent = this.labelContent.bind(this); }

  ngOnInit(): void {
    this.improveService._improveComponent.DefaultComponent = this;
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    // this.getAllValuesOfFilter();
    this.screenWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.screenWidth = window.innerWidth;
  }

  onChangeReportType(event: any) {
    this.selctReportOption = event.value;
    if (event.value == this.selectReportTypeOptions[0].value) {
      this.monthBool = true;
      this.quarterBool = false;
      this.quarterYearBool = false;
      this.Month = '';
      this.selectedQuarter = '';
    } else {
      this.quarterYearBool = true;
      this.quarterBool = false;
      this.monthBool = false;
      this.YearQuarter = '';
      this.selectedQuarter = '';
      this.Month = '';
    }
  }
  onChangeYearQuarter(event: any) {
    this.quarterBool = true
  }

  onChangeFilterType(event: any) {
    this.event = event.value;
    if (event.value == this.selectedFacilityOptions[0].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectFacilityData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 1;
      this.filterTypeBool = true;
      this.spokeSiteBool = false;
    }
    if (event.value == this.selectedFacilityOptions[1].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectSystemData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 2;
      this.filterTypeBool = true;
      this.spokeSiteBool = true;
    }
    if (event.value == this.selectedFacilityOptions[2].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectRegionData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 3;
      this.filterTypeBool = true;
      this.spokeSiteBool = true;
    }
  }
  // getAllValuesOfFilter() {
  //   this.subscription.push(
  //     this.analyzeService.GetFacilityPIList(this.RoleName, this.UId).subscribe({
  //       next: (res: any) => {
  //         if (res) {
  //           let filter = { value: this.event };
  //           this.FilterList = res;
  //           this.onChangeFilterType(filter);
  //         }
  //       },
  //       error: (err: any) => { },
  //     })
  //   );
  // }
  GetAllData(req: any) {
    if ((this.SelectFacilityData.length == 0 && req == 'facility') || 
    (this.SelectSystemData.length == 0 && req == 'system') ||
    (this.SelectRegionData.length == 0 && req == 'regional')) {
      this.showProgressSpinner = true
      let obj: any = {};
      if (req == 'facility') {
        obj.fieldName = 'facility';
        obj.value = 'facility';
      } else if(req == 'system') {
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '42';
      }else{
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '43';
    }
      this.subscription.push(
        this.analyzeService.GetAllData(obj, this.RoleName, this.UId).subscribe({
          next: (res: any) => {
            if (res) {
              this.showProgressSpinner = false;
              if (req == 'facility') {
                this.SelectFacilityData = res.data;
                this.SelectListFilter = res.data;
              } else if(req == 'system') {
                this.SelectSystemData = res.data;
                this.SelectListFilter = res.data;
              }else{
                this.SelectRegionData = res.data;
                this.SelectListFilter = res.data;
              }
              // let filter = { value: this.event };

              // this.FilterList = res;
              // this.SelectFacilityData = res.data;
              // this.onChangeFilterType(filter);
            }
          },
          error: (err: any) => { },
        })
      );
    }
  }


  // Get facility Text Code
  getSelectedValue(data: any) {
    this.selectedOptionTextTemp = data.selectedOption.Text;
    this.selectedOptionText = data.selectedOption.Text;
  }

  getImproveData() {
    let facilityVal: any = null;
    let systemVal: any = null;
    let regionVal: any = null;
    let Year: any;
    let selectedQuarter: any;
    if (this.selectedFilterType == 'facility') {
      facilityVal = this.selectFacilityPIOptions;
    } else if (this.selectedFilterType == 'system') {
      systemVal = this.selectFacilityPIOptions;
    } else if (this.selectedFilterType == 'regional') {
      regionVal = this.selectFacilityPIOptions;
    }
    if (this.SelectedReportType == "quarterly") {
      Year = this.datePipe.transform(this.YearQuarter, 'yyyy');
      selectedQuarter = this.selectedQuarter;
    }
    let quarter_number = 0;
    switch (this.selectedQuarter) {
      case 'quarter1': quarter_number = 1; break;
      case 'quarter2': quarter_number = 2; break;
      case 'quarter3': quarter_number = 3; break;
      case 'quarter4': quarter_number = 4; break;
    }
    let obj = {
      fac_key: facilityVal,
      system: systemVal,
      SpokeSiteFilter: this.spokeSite,
      Regional: regionVal,
      month_of_year: this.selected_Month_Of_Year,
      quarter_year: Year,
      quarter_number: quarter_number
    }
    this.subscription.push(
      this.improveService.GetImproveData(obj).subscribe({
        next: (res: any) => {
          this.isShow = true;
          this.noRecordFoundDataBool = false;
          this.qti_opportunities_pi_projects = res?.data?.qti_opportunities_pi_projects ? res?.data?.qti_opportunities_pi_projects: '';
          this.qti_opportunities_pi_projects_temp = res?.data?.qti_opportunities_pi_projects ? res?.data?.qti_opportunities_pi_projects : '';
          this.qti_accomplishments_improvements = res?.data?.qti_accomplishments_improvements ? res?.data?.qti_accomplishments_improvements : '';
          this.qti_accomplishments_improvements_temp = res?.data?.qti_accomplishments_improvements ?res?.data?.qti_accomplishments_improvements : '';
          this.for_compare_textarea_data_on_save = res?.data;
          this.qti_case_key = res?.data?.qti_fac_key;
          this.qti_Id = res?.data?.qti_id;
          this.qti_data_by_month_of_year = res?.data?.qti_data_by_month_of_year;
          this.qti_quarter_year = res?.data?.qti_quarter_year;
          this.qti_quarter_number = res?.data?.qti_quarter_number;
          this.qti_data = res.data;
          // this.improveSearchLoader = false;
          // this.showProgressSpinner = false;
        },
        error: (err: any) => {
        }
      })
    );
  }

  CheckPostImproveData(type: any) {
    if (!this.isChangeTextBox) {
      this.PostImproveData(type);
    }
  }
  PostImproveData(type: any) {
    let facilityVal: any = null;
    let systemVal: any = null;
    let regionVal: any = null;
    // this.qti_accomplishments_improvements = this.qti_accomplishments_improvements ? this.qti_accomplishments_improvements.replace(/\n\//g, '<br>') : '';
    // this.qti_opportunities_pi_projects = this.qti_opportunities_pi_projects ? this.qti_opportunities_pi_projects.replace(/\n\//g, '<br>') : '';
    if (this.selectedFilterType == 'facility') {
      facilityVal = this.selectFacilityPIOptions;
    } else if (this.selectedFilterType == 'system') {
      systemVal = this.selectFacilityPIOptions;
    }else if (this.selectedFilterType == 'regional') {
      regionVal = this.selectFacilityPIOptions;
    }
    let quarter_number = 0;
    switch (this.selectedQuarter) {
      case 'quarter1': quarter_number = 1; break;
      case 'quarter2': quarter_number = 2; break;
      case 'quarter3': quarter_number = 3; break;
      case 'quarter4': quarter_number = 4; break;
    }
    let Year = this.datePipe.transform(this.YearQuarter, 'yyyy');
    this.improveSaveLoader = true;
    this.showProgressSpinner = true;
    let qtiDataExist =  this.qti_Id && (this.SelectedReportType == 'monthly' && this.Month.toLocaleDateString() == new Date(this.qti_data_by_month_of_year).toLocaleDateString() || (this.SelectedReportType == 'quarterly' && this.YearQuarter?.getFullYear() == this.qti_quarter_year && quarter_number == this.qti_quarter_number)) ? true : false;
    let obj = [{
      qti_fac_key: facilityVal,
      qti_id: qtiDataExist ? this.qti_Id : 0,
      qti_system_key: systemVal,
      SpokeSiteFilter: this.spokeSite,
      qti_regional_key: regionVal,
      qti_quarter_year: this.YearQuarter == null || this.YearQuarter == '' ? null : Year,
      qti_quarter_number: quarter_number,
      qti_accomplishments_improvements: btoa(unescape(encodeURIComponent(this.qti_accomplishments_improvements))),
      qti_opportunities_pi_projects: btoa(unescape(encodeURIComponent(this.qti_opportunities_pi_projects))),
      qti_created_by: qtiDataExist ? this.qti_data.qti_created_by : this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
      qti_created_by_name: qtiDataExist ? this.qti_data.qti_created_by_name : this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
      qti_created_by_date: qtiDataExist ? this.qti_data.qti_created_by_date : new Date(),
      qti_modified_by: qtiDataExist ? this.helperService.decryption(localStorage.getItem(LocalStorage.UId)) : null,
      qti_modified_by_name: qtiDataExist ? this.helperService.decryption(localStorage.getItem(LocalStorage.UName)) : null,
      qti_modified_by_date: qtiDataExist ? new Date() : null,
      qti_data_by_month_of_year: this.selected_Month_Of_Year,
      qti_generate_monthly_report: btoa(this.improveTemplate)
    }]
    this.subscription.push(
      this.improveService.InsertUpdateImproveData(obj).subscribe({
        next: (res) => {
          this.showProgressSpinner = false;
          if (type == 'PostImproveData') {
            this.getImproveData();
            this.toastrNotificaion.DataAdded();
            this.isChangeTextBox = true;
            this.improveSaveLoader = false;
          } else if (type == 'saveTemplate') {
            this.toastrNotificaion.message('Improve Template Save Successfuly.');
          } else if (type == 'save & closeTemplate') {
            this.toastrNotificaion.message('Improve Template Save Successfuly.');
            this.generateTemplatebool = false;
          }

        },
        error: (err: any) => {
        }
      })
    );
  }

  getFacilityDashboardValues() {
    if (this.selectedFilterType != null && this.SelectedReportType != null && this.selectFacilityPIOptions != null && this.Month != "" ||
      this.selectedFilterType != null && this.SelectedReportType != null && this.selectFacilityPIOptions != null && this.YearQuarter != "" && this.selectedQuarter != '') {
      this.FilterDashboardImproveList = [];
      this.FilterDashboardImproveListReplica = [];
      this.improveSearchLoader = true;
      this.showProgressSpinner = true;
      let facilityVal: any = [];
      let systemVal: any = [];
      let regionVal: any = [];
      let year: any;
      let fromMonth: any;
      let toMonth: any;
      if (this.SelectedReportType == "monthly") {
        this.selected_Month_Of_Year = this.datePipe.transform(this.Month, 'MM/dd/yyyy');
        fromMonth = this.datePipe.transform(this.Month, 'MM/dd/yyyy');
        toMonth = this.datePipe.transform(this.Month, 'MM/dd/yyyy');
        year = this.datePipe.transform(this.Month, 'yyyy');
        this.selectedQuarter = '';
      }
      else if (this.SelectedReportType == "quarterly") {
        this.selected_Month_Of_Year = null;
        year = this.datePipe.transform(this.YearQuarter, 'yyyy');

        switch (this.selectedQuarter) {
          case 'quarter1':
            fromMonth = `01/01/${year}`;
            toMonth = `03/01/${year}`;
            break;
          case 'quarter2':
            fromMonth = `04/01/${year}`;
            toMonth = `06/01/${year}`;
            break;
          case 'quarter3':
            fromMonth = `07/01/${year}`;
            toMonth = `09/01/${year}`;
            break;
          default:
            fromMonth = `10/01/${year}`;
            toMonth = `12/01/${year}`;
            break;
        }
        this.sMonth = ''
      }
      if (this.selectedFilterType == 'facility') {
        facilityVal.push(this.selectFacilityPIOptions);
      } else if (this.selectedFilterType == 'system') {
        systemVal.push(this.selectFacilityPIOptions);
      } else if (this.selectedFilterType == 'regional') {
          regionVal.push(this.selectFacilityPIOptions);
      }


      // Rapidi Notification
      let rapidiData = {
        Take: 10000,
        Skip: 0,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        Filter: {
          field: '',
          operator: '',
          value: this.filterVal,
          logic: '',
          filters: [],
        },
        searchString: this.filterVal,
        PageNumber: this.pageNumber,
        serviceType: [],
        data: {
          Facilities: facilityVal,
          System: systemVal,
          Regional: regionVal,
          States: this.States,
          QPS: this.QPS,
          ByPIFacility: this.ByPIFacility,
          fromMonth: fromMonth,
          toMonth: toMonth,
          QualityGoalsData: null,
          ReportType: 'monthly',
          PatientType: [1, 2, 3, 4],
          ActiveNonActiveFacility: this.active,
          FilterType: this.selectedFilterType,
          qag_time_frame: `${year}-1-1`,
          Status: this.analyzeService._statusValue,
          SpokeSiteFilter: this.spokeSite,
          PreArrivalAll: 0,
          PreArrivalYes: 1,
        },
      };
      this.improveFacilityData = rapidiData;
      this.subscription.push(
        this.improveService.GetImproveRapidi(rapidiData, this.UId, this.RoleName).subscribe({
          next: (res: any) => {
            if(res.GetACTIrapidinotification.dataAll != null){
            this.isChangeTextBox = true;
            let WorkFlowTypeAllArivalCount = 0;
            this.activationTimeListQualifyCountTriage = 0;
            this.activationEMSTimeCasesMean = 0;
            this.activationEMSTimeCasesMedian = 0;
            this.activationEMSTimeCasesMaximum = 0;
            this.activationTriageTimeCasesMean = 0;
            this.activationTriageTimeCasesMedian = 0;
            this.activationTriageTimeCasesMaximum = 0

            if (res) {
              this.activationTimeListQualifyCountEMS = 0;
              // Count Total REcord of activatione ems
              this.activationEMSTimeList = res.GetACTIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'ems' && arr.cas_Pre_Arrival == 1;
              });

              WorkFlowTypeAllArivalCount = res.GetACTIrapidinotification.TotalEMS;
              this.activationTotalRecords = res.GetACTIrapidinotification.TotalEMS;
              this.activationTgTotalRecords = res.GetACTIrapidinotification.TgTotal;
              // Count Total REcord of activatione ems
              this.activationEMSTotalRecords = this.activationEMSTimeList.length;

              // Count Total REcord of activatione Triage
              this.activationTriageTimeList = res.GetACTIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'triage/walk-in';
              });
              // Count Total REcord of activatione Triage
              this.activationTriageTotalRecords = this.activationTriageTimeList.length;
              //For EMS
              if (this.activationEMSTotalRecords > 0) {
                this.activationEMSTimeList.forEach((element: any) => {
                  if (element.ActivationTimeInterval > 0) {
                    this.activationTimeListQualifyCountEMS++;
                  }
                  this.activationEMSTimeCasesMean += Number(element.ActivationTimeInterval);
                });
                //Mean of Activation EMS
                this.activationEMSTimeCasesMean /= this.activationEMSTotalRecords;
                this.activationEMSTimeCasesMean = Math.round(this.activationEMSTimeCasesMean);
                //Median of Activation EMS
                let activationEMSTimeSortCases = this.activationEMSTimeList.sort(function (a: any, b: any) { return a.ActivationTimeInterval - b.ActivationTimeInterval });
                let activationEMSTimeMid = Math.round(Number(this.activationEMSTotalRecords) / 2);
                if ((activationEMSTimeMid % 2 != 0 && activationEMSTimeMid != 1) || Number(this.activationEMSTotalRecords) == 2) {
                  this.activationEMSTimeCasesMedian = Number(activationEMSTimeSortCases[activationEMSTimeMid - 1]?.ActivationTimeInterval) + Number(activationEMSTimeSortCases[activationEMSTimeMid]?.ActivationTimeInterval);
                  this.activationEMSTimeCasesMedian = Math.round(this.activationEMSTimeCasesMedian / 2);
                }
                else {
                  activationEMSTimeMid = Math.round(activationEMSTimeMid);
                  this.activationEMSTimeCasesMedian = Number(activationEMSTimeSortCases[activationEMSTimeMid - 1]?.ActivationTimeInterval);
                }
                //Maximum of Activation Cases
                this.activationEMSTimeCasesMaximum = Number(this.activationEMSTimeList[this.activationEMSTotalRecords - 1]?.ActivationTimeInterval);
              }
              //For Triage

              if (this.activationTriageTotalRecords > 0) {
                this.activationTriageTimeList.forEach((element: any) => {
                  if (element.ActivationTimeInterval > 10) {
                    this.activationTimeListQualifyCountTriage++;
                  }
                  this.activationTriageTimeCasesMean += Number(element.ActivationTimeInterval);
                });
                //Mean of Activation
                this.activationTriageTimeCasesMean /= this.activationTriageTotalRecords;
                this.activationTriageTimeCasesMean = Math.round(this.activationTriageTimeCasesMean);
                //Median of Activation
                let activationTriageTimeSortCases = this.activationTriageTimeList.sort(function (a: any, b: any) { return a.ActivationTimeInterval - b.ActivationTimeInterval });
                let activationTriageTimeMid = Math.round(Number(this.activationTriageTotalRecords) / 2);
                if ((activationTriageTimeMid % 2 != 0 && activationTriageTimeMid != 1) || Number(this.activationTriageTotalRecords) == 2) {
                  this.activationTriageTimeCasesMedian = Number(activationTriageTimeSortCases[activationTriageTimeMid - 1]?.ActivationTimeInterval) + Number(activationTriageTimeSortCases[activationTriageTimeMid]?.ActivationTimeInterval);
                  this.activationTriageTimeCasesMedian = Math.round(this.activationTriageTimeCasesMedian / 2);
                }
                else {
                  activationTriageTimeMid = Math.round(activationTriageTimeMid);
                  this.activationTriageTimeCasesMedian = Number(activationTriageTimeSortCases[activationTriageTimeMid - 1]?.ActivationTimeInterval);
                }
                //Maximum of Activation Cases
                this.activationTriageTimeCasesMaximum = Number(this.activationTriageTimeList[this.activationTriageTotalRecords - 1]?.ActivationTimeInterval);
              }

              this.assessmentTimeListQualifyCountEMS = 0;
              this.assessmentTimeListQualifyCountTriage = 0;
              this.assessmentTimeListQualifyCountInpatient = 0;
              this.assessmentTimeListQualifyCountEDOnset = 0;
              this.assessmentEMSTimeCasesMean = 0;
              this.assessmentEMSTimeCasesMedian = 0;
              this.assessmentEMSTimeCasesMaximum = 0;
              this.assessmentTriageTimeCasesMean = 0;
              this.assessmentInpatientTimeCasesMean = 0;
              this.assessmentEDOnsetTimeCasesMean = 0;
              this.assessmentTriageTimeCasesMedian = 0;
              this.timeCasesMedian = 0;
              this.assessmentInpatientTimeCasesMedian = 0;
              this.assessmentEDOnsetTimeCasesMedian = 0;
              this.assessmentTriageTimeCasesMaximum = 0;
              this.timeCasesMaximum = 0;
              this.assessmentInpatientTimeCasesMaximum = 0;
              this.assessmentEDOnsetTimeCasesMaximum = 0;

              this.assessmentEMSTimeList = res.GetASTIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'ems';
              });
              this.assessmentTotalRecords = res.GetASTIrapidinotification.TotalEMS;
              this.assessmentTotalInpatientRecords = res.GetASTIrapidinotification.TotalInpatient;
              this.assessmentTotalTriageRecords = res.GetASTIrapidinotification.TotalTriage;
              this.assessmentTotalEDOnsetRecords = res.GetASTIrapidinotification.TotalEDOnset;
              // Count Total REcord of assessmente ems
              this.assessmentEMSTotalRecords = this.assessmentEMSTimeList.length;





              // Count Total REcord of assessmente Inpatient
              this.assessmentInpatientTimeList = res.GetASTIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'inpatient';
              });
              // Count Total REcord of assessmente Inpatient
              this.assessmentInpatientTotalRecords = this.assessmentInpatientTimeList.length;






              // Count Total REcord of assessmente Triage
              this.assessmentTriageTimeList = res.GetASTIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'triage/walk-in';
              });
              // Count Total REcord of assessmente Triage
              this.assessmentTriageTotalRecords = this.assessmentTriageTimeList.length;





              // Count Total REcord of assessmente ED Onset
              this.assessmentEDOnsetTimeList = res.GetASTIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'ed onset';
              });
              // Count Total REcord of assessmente ED Onset
              this.assessmentEDOnsetTotalRecords = this.assessmentEDOnsetTimeList.length;




              // For EMS
              if (this.assessmentEMSTotalRecords > 0) {
                this.assessmentEMSTimeList.forEach((element: any) => {
                  if (element.AssessmentTimeInterval > 12) {
                    this.assessmentTimeListQualifyCountEMS++;
                  }
                  this.assessmentEMSTimeCasesMean += Number(element.AssessmentTimeInterval);
                });
                //Mean of Activation
                this.assessmentEMSTimeCasesMean /= this.assessmentEMSTotalRecords;
                this.assessmentEMSTimeCasesMean = Math.round(this.assessmentEMSTimeCasesMean);
                //Median of Assessment
                let assessmentEMSTimeSortCases = this.assessmentEMSTimeList.sort(function (a: any, b: any) { return a.AssessmentTimeInterval - b.AssessmentTimeInterval });
                let assessmentEMSTimeCaseMid = Math.round(Number(this.assessmentEMSTotalRecords) / 2);
                if ((assessmentEMSTimeCaseMid % 2 != 0 && assessmentEMSTimeCaseMid != 1) || Number(this.assessmentEMSTotalRecords) == 2) {
                  this.assessmentEMSTimeCasesMedian = Number(assessmentEMSTimeSortCases[assessmentEMSTimeCaseMid - 1]?.AssessmentTimeInterval) + Number(assessmentEMSTimeSortCases[assessmentEMSTimeCaseMid]?.AssessmentTimeInterval);
                  this.assessmentEMSTimeCasesMedian = Math.round(this.assessmentEMSTimeCasesMedian / 2);
                }
                else {
                  assessmentEMSTimeCaseMid = Math.round(assessmentEMSTimeCaseMid);
                  this.assessmentEMSTimeCasesMedian = Number(assessmentEMSTimeSortCases[assessmentEMSTimeCaseMid - 1]?.AssessmentTimeInterval);
                }
                //Maximum of Assessment Cases
                this.assessmentEMSTimeCasesMaximum = Number(this.assessmentEMSTimeList[this.assessmentEMSTotalRecords - 1]?.AssessmentTimeInterval);
              }
              // For Inpatient
              if (this.assessmentInpatientTotalRecords > 0) {
                this.assessmentInpatientTimeList.forEach((element: any) => {
                  if (element.AssessmentTimeInterval > 12) {
                    this.assessmentTimeListQualifyCountInpatient++;
                  }
                  this.assessmentInpatientTimeCasesMean += Number(element.AssessmentTimeInterval);
                });
                this.CalculateMeanMedian(this.assessmentInpatientTimeCasesMean, this.assessmentInpatientTotalRecords, this.assessmentInpatientTimeList, 'inpatient', 'assesment');
              }
              // For Triage
              if (this.assessmentTriageTotalRecords > 0) {
                this.assessmentTriageTimeList.forEach((element: any) => {
                  if (element.AssessmentTimeInterval > 12) {
                    this.assessmentTimeListQualifyCountTriage++;
                  }
                  this.assessmentTriageTimeCasesMean += Number(element.AssessmentTimeInterval);
                });
                this.CalculateMeanMedian(this.assessmentTriageTimeCasesMean, this.assessmentTriageTotalRecords, this.assessmentTriageTimeList, 'triage', 'assesment');
              }
              // For ED Onset
              if (this.assessmentEDOnsetTotalRecords > 0) {
                this.assessmentEDOnsetTimeList.forEach((element: any) => {
                  if (element.AssessmentTimeInterval > 12) {
                    this.assessmentTimeListQualifyCountEDOnset++;
                  }
                  this.assessmentEDOnsetTimeCasesMean += Number(element.AssessmentTimeInterval);
                });
                this.CalculateMeanMedian(this.assessmentEDOnsetTimeCasesMean, this.assessmentEDOnsetTotalRecords, this.assessmentEDOnsetTimeList, 'edonset', 'assesment');
              }


              this.thrombolyticDecisionTimeListQualifyCountEMS = 0;
              this.thrombolyticDecisionTimeListQualifyCountTriage = 0;
              this.thrombolyticDecisionTimeListQualifyCountInpatient = 0;
              this.thrombolyticDecisionTimeListQualifyCountEDOnset = 0;
              this.thrombolyticDecisionEMSTimeCasesMean = 0;
              this.thrombolyticDecisionEMSTimeCasesMedian = 0;
              this.thrombolyticDecisionEMSTimeCasesMaximum = 0;
              this.thrombolyticDecisionTriageTimeCasesMean = 0;
              this.thrombolyticDecisionInpatientTimeCasesMean = 0;
              this.thrombolyticDecisionEDOnsetTimeCasesMean = 0;
              this.thrombolyticDecisionTriageTimeCasesMedian = 0;
              this.thrombolyticDecisionInpatientTimeCasesMedian = 0;
              this.thrombolyticDecisionEDOnsetTimeCasesMedian = 0;
              this.thrombolyticDecisionTriageTimeCasesMaximum = 0;
              this.thrombolyticDecisionInpatientTimeCasesMaximum = 0;
              this.thrombolyticDecisionEDOnsetTimeCasesMaximum = 0;

              this.thrombolyticDecisionEMSTimeList = res?.GetTHDIrapidinotification?.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'ems';
              });
              this.thrombolyticDecisionTotalRecords = res.GetTHDIrapidinotification.TotalEMS;
              this.thrombolyticDecisionTotalInpatientRecords = res.GetTHDIrapidinotification.TotalInpatient;
              this.thrombolyticDecisionTotalTriageRecords = res.GetTHDIrapidinotification.TotalTriage;
              this.thrombolyticDecisionEDOnsetRecords = res.GetTHDIrapidinotification.TotalEDOnset;
              // Count Total REcord of thromblyticDecisione ems
              this.thrombolyticDecisionEMSTotalRecords = this.thrombolyticDecisionEMSTimeList.length;

              // Count Total REcord of thromblyticDecisione Inpatient
              this.thrombolyticDecisionInpatientTimeList = res.GetTHDIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'inpatient';
              });
              // Count Total REcord of thromblyticDecisione Inpatient
              this.thrombolyticDecisionInpatientTotalRecords = this.thrombolyticDecisionInpatientTimeList.length;



              // Count Total REcord of thromblyticDecisione Triage
              this.thrombolyticDecisionTriageTimeList = res.GetTHDIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'triage/walk-in';
              });
              // Count Total REcord of thromblyticDecisione Triage
              this.thrombolyticDecisionTriageTotalRecords = this.thrombolyticDecisionTriageTimeList.length;



              // Count Total REcord of thromblyticDecisione ED Onset
              this.thrombolyticDecisionEDOnsetTimeList = res.GetTHDIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'ed onset';
              });
              // Count Total REcord of thromblyticDecisione ED Onset
              this.thrombolyticDecisionEDOnsetTotalRecords = this.thrombolyticDecisionEDOnsetTimeList.length;





              // For EMS
              if (this.thrombolyticDecisionEMSTotalRecords > 0) {
                this.thrombolyticDecisionEMSTimeList.forEach((element: any) => {
                  if (element.ThrombolyticDecisionInterval > 10) {
                    this.thrombolyticDecisionTimeListQualifyCountEMS++;
                  }
                  this.thrombolyticDecisionEMSTimeCasesMean += Number(element.ThrombolyticDecisionInterval);
                });
                //Mean of Thrombolytic Decision
                this.thrombolyticDecisionEMSTimeCasesMean /= this.thrombolyticDecisionEMSTotalRecords;
                this.thrombolyticDecisionEMSTimeCasesMean = Math.round(this.thrombolyticDecisionEMSTimeCasesMean);
                //Median of Thrombolytic Decision
                let thrombolyticDecisionEMSSortCases = this.thrombolyticDecisionEMSTimeList.sort(function (a: any, b: any) { return a.ThrombolyticDecisionInterval - b.ThrombolyticDecisionInterval });
                let thrombolyticDecisionEMSCaseMid = Math.round(Number(this.thrombolyticDecisionEMSTotalRecords) / 2);
                if ((thrombolyticDecisionEMSCaseMid % 2 != 0 && thrombolyticDecisionEMSCaseMid != 1) || Number(this.thrombolyticDecisionEMSTotalRecords) == 2) {
                  this.thrombolyticDecisionEMSTimeCasesMedian = Number(thrombolyticDecisionEMSSortCases[thrombolyticDecisionEMSCaseMid - 1]?.ThrombolyticDecisionInterval) + Number(thrombolyticDecisionEMSSortCases[thrombolyticDecisionEMSCaseMid]?.ThrombolyticDecisionInterval);
                  this.thrombolyticDecisionEMSTimeCasesMedian = Math.round(this.thrombolyticDecisionEMSTimeCasesMedian / 2);
                }
                else {
                  thrombolyticDecisionEMSCaseMid = Math.round(thrombolyticDecisionEMSCaseMid);
                  this.thrombolyticDecisionEMSTimeCasesMedian = Number(thrombolyticDecisionEMSSortCases[thrombolyticDecisionEMSCaseMid - 1]?.ThrombolyticDecisionInterval);
                }
                //Maximum of Thrombolytic Decision
                this.thrombolyticDecisionEMSTimeCasesMaximum = Number(this.thrombolyticDecisionEMSTimeList[this.thrombolyticDecisionEMSTotalRecords - 1]?.ThrombolyticDecisionInterval);
              }

              // For Inpatient
              if (this.thrombolyticDecisionInpatientTotalRecords > 0) {
                this.thrombolyticDecisionInpatientTimeList.forEach((element: any) => {
                  if (element.ThrombolyticDecisionInterval > 10) {
                    this.thrombolyticDecisionTimeListQualifyCountInpatient++;
                  }
                  this.thrombolyticDecisionInpatientTimeCasesMean += Number(element.ThrombolyticDecisionInterval);
                });
                this.CalculateMeanMedian(this.thrombolyticDecisionInpatientTimeCasesMean, this.thrombolyticDecisionInpatientTotalRecords, this.thrombolyticDecisionInpatientTimeList, 'inpatient', 'thrombolyticDecision');
              }

              // For Triage
              if (this.thrombolyticDecisionTriageTotalRecords > 0) {
                this.thrombolyticDecisionTriageTimeList.forEach((element: any) => {
                  if (element.ThrombolyticDecisionInterval > 10) {
                    this.thrombolyticDecisionTimeListQualifyCountTriage++;
                  }
                  this.thrombolyticDecisionTriageTimeCasesMean += Number(element.ThrombolyticDecisionInterval);
                });
                this.CalculateMeanMedian(this.thrombolyticDecisionTriageTimeCasesMean, this.thrombolyticDecisionTriageTotalRecords, this.thrombolyticDecisionTriageTimeList, 'triage', 'thrombolyticDecision');

              }

              // For ED Onset
              if (this.thrombolyticDecisionEDOnsetTotalRecords > 0) {
                this.thrombolyticDecisionEDOnsetTimeList.forEach((element: any) => {
                  if (element.ThrombolyticDecisionInterval > 10) {
                    this.thrombolyticDecisionTimeListQualifyCountEDOnset++;
                  }
                  this.thrombolyticDecisionEDOnsetTimeCasesMean += Number(element.ThrombolyticDecisionInterval);
                });
                this.CalculateMeanMedian(this.thrombolyticDecisionEDOnsetTimeCasesMean, this.thrombolyticDecisionEDOnsetTotalRecords, this.thrombolyticDecisionEDOnsetTimeList, 'edonset', 'thrombolyticDecision');

              }

              this.thrombolyticAdministrationTimeListQualifyCountEMS = 0;
              this.thrombolyticAdministrationTimeListQualifyCountTriage = 0;
              this.thrombolyticAdministrationTimeListQualifyCountInpatient = 0;
              this.thrombolyticAdministrationTimeListQualifyCountEDOnset = 0;
              this.thrombolyticAdministrationEMSTimeCasesMean = 0;
              this.thrombolyticAdministrationEMSCasesMedian = 0;
              this.thrombolyticAdministrationEMSTimeCasesMaximum = 0;
              this.thrombolyticAdministrationTriageTimeCasesMean = 0;
              this.thrombolyticAdministrationInpatientTimeCasesMean = 0;
              this.thrombolyticAdministrationEDOnsetTimeCasesMean = 0;
              this.thrombolyticAdministrationTriageTimeCasesMedian = 0;
              this.thrombolyticAdministrationInpatientTimeCasesMedian = 0;
              this.thrombolyticAdministrationEDOnsetTimeCasesMedian = 0;
              this.thrombolyticAdministrationTriageTimeCasesMaximum = 0;
              this.thrombolyticAdministrationInpatientTimeCasesMaximum = 0;
              this.thrombolyticAdministrationEDOnsetTimeCasesMaximum = 0;

              this.thrombolyticAdministrationEMSTimeList = res.GetTHAIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'ems';
              });
              this.thrombolyticAdministrationTotalRecords = res.GetTHAIrapidinotification.TotalEMS;
              this.thrombolyticAdministrationTotalInpatientRecords = res.GetTHAIrapidinotification.TotalInpatient;
              this.thrombolyticAdministrationTotalTriageRecords = res.GetTHAIrapidinotification.TotalTriage;
              this.thrombolyticAdministrationTotalEDOnsetRecords = res.GetTHAIrapidinotification.TotalEDOnset;
              // Count Total REcord of thromblyticDecisione ems
              this.thrombolyticAdministrationEMSTotalRecords = this.thrombolyticAdministrationEMSTimeList.length;

              // Count Total REcord of thromblyticDecisione Inpatient
              this.thrombolyticAdministrationInpatientTimeList = res.GetTHAIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'inpatient';
              });
              // Count Total REcord of thromblyticDecisione Inpatient
              this.thrombolyticAdministrationInpatientTotalRecords = this.thrombolyticAdministrationInpatientTimeList.length;


              // Count Total REcord of thromblyticDecisione Triage
              this.thrombolyticAdministrationTriageTimeList = res.GetTHAIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'triage/walk-in';
              });
              // Count Total REcord of thromblyticDecisione Triage
              this.thrombolyticAdministrationTriageTotalRecords = this.thrombolyticAdministrationTriageTimeList.length;



              // Count Total REcord of thromblyticDecisione ED Onset
              this.thrombolyticAdministrationEDOnsetTimeList = res.GetTHAIrapidinotification.dataAll.filter((arr: any) => {
                return arr.WorkFlowType.toLowerCase() == 'ed onset';
              });
              // Count Total REcord of thromblyticDecisione ED Onset
              this.thrombolyticAdministrationEDOnsetTotalRecords = this.thrombolyticAdministrationEDOnsetTimeList.length;

              // For EMS
              if (this.thrombolyticAdministrationEMSTotalRecords > 0) {
                this.thrombolyticAdministrationEMSTimeList?.forEach((element: any) => {
                  if (element.ThrombolyticAdministrationInterval > 8) {
                    this.thrombolyticAdministrationTimeListQualifyCountEMS++;
                  }
                  this.thrombolyticAdministrationEMSTimeCasesMean += Number(element.ThrombolyticAdministrationInterval);
                });
                //Mean of Thrombolytic Administration
                this.thrombolyticAdministrationEMSTimeCasesMean /= this.thrombolyticAdministrationEMSTotalRecords;
                this.thrombolyticAdministrationEMSTimeCasesMean = Math.round(this.thrombolyticAdministrationEMSTimeCasesMean);
                //Median of Thrombolytic Administration
                let thrombolyticAdministrationEMSSortCases = this.thrombolyticAdministrationEMSTimeList.sort(function (a: any, b: any) { return a.ThrombolyticAdministrationInterval - b.ThrombolyticAdministrationInterval })
                let thrombolyticAdministrationEMSCaseMid = Math.round(Number(this.thrombolyticAdministrationEMSTotalRecords) / 2);
                if ((thrombolyticAdministrationEMSCaseMid % 2 != 0 && thrombolyticAdministrationEMSCaseMid != 1) || Number(this.thrombolyticAdministrationEMSTotalRecords) == 2) {
                  this.thrombolyticAdministrationEMSCasesMedian = Number(thrombolyticAdministrationEMSSortCases[thrombolyticAdministrationEMSCaseMid - 1]?.ThrombolyticAdministrationInterval) + Number(thrombolyticAdministrationEMSSortCases[thrombolyticAdministrationEMSCaseMid]?.ThrombolyticAdministrationInterval);
                  this.thrombolyticAdministrationEMSCasesMedian = Math.round(this.thrombolyticAdministrationEMSCasesMedian / 2);
                }
                else {
                  thrombolyticAdministrationEMSCaseMid = Math.round(thrombolyticAdministrationEMSCaseMid);
                  this.thrombolyticAdministrationEMSCasesMedian = Number(thrombolyticAdministrationEMSSortCases[thrombolyticAdministrationEMSCaseMid - 1]?.ThrombolyticAdministrationInterval);
                }
                //Maximum of Thrombolytic Administration
                this.thrombolyticAdministrationEMSTimeCasesMaximum = Number(this.thrombolyticAdministrationEMSTimeList[this.thrombolyticAdministrationEMSTotalRecords - 1]?.ThrombolyticAdministrationInterval);
              }
              // For Inpatient
              if (this.thrombolyticAdministrationInpatientTotalRecords > 0) {
                this.thrombolyticAdministrationInpatientTimeList?.forEach((element: any) => {
                  if (element.ThrombolyticAdministrationInterval > 8) {
                    this.thrombolyticAdministrationTimeListQualifyCountInpatient++;
                  }
                  this.thrombolyticAdministrationInpatientTimeCasesMean += Number(element.ThrombolyticAdministrationInterval);
                });
                this.CalculateMeanMedian(this.thrombolyticAdministrationInpatientTimeCasesMean, this.thrombolyticAdministrationInpatientTotalRecords, this.thrombolyticAdministrationInpatientTimeList, 'inpatient', 'thrombolyticAdministration');
              }
              // For Triage
              if (this.thrombolyticAdministrationTriageTotalRecords > 0) {
                this.thrombolyticAdministrationTriageTimeList?.forEach((element: any) => {
                  if (element.ThrombolyticAdministrationInterval > 8) {
                    this.thrombolyticAdministrationTimeListQualifyCountTriage++;
                  }
                  this.thrombolyticAdministrationTriageTimeCasesMean += Number(element.ThrombolyticAdministrationInterval);
                });
                this.CalculateMeanMedian(this.thrombolyticAdministrationTriageTimeCasesMean, this.thrombolyticAdministrationTriageTotalRecords, this.thrombolyticAdministrationTriageTimeList, 'triage', 'thrombolyticAdministration');
              }
              // For ED Onset
              if (this.thrombolyticAdministrationEDOnsetTotalRecords > 0) {
                this.thrombolyticAdministrationEDOnsetTimeList?.forEach((element: any) => {
                  if (element.ThrombolyticAdministrationInterval > 8) {
                    this.thrombolyticAdministrationTimeListQualifyCountEDOnset++;
                  }
                  this.thrombolyticAdministrationEDOnsetTimeCasesMean += Number(element.ThrombolyticAdministrationInterval);
                });
                this.CalculateMeanMedian(this.thrombolyticAdministrationEDOnsetTimeCasesMean, this.thrombolyticAdministrationEDOnsetTotalRecords, this.thrombolyticAdministrationEDOnsetTimeList, 'edonset', 'thrombolyticAdministration');
              }
              this.getRAPIDNotificationValuesList = res;

              this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList = this.getRAPIDNotificationValuesList;
              this.analyzeService.currentDateTime();

              // Rapidi PreArrivaYes Case

              let WorkFlowTypeYesArrivalCount = 0;
              res.GetACTIrapidinotification?.dataAll?.forEach((element: any) => {
                if (element.WorkFlowType == 'EMS' && element.cas_Pre_Arrival == 0) {
                  WorkFlowTypeYesArrivalCount++;
                }
              });
              if ((Number.isNaN(WorkFlowTypeYesArrivalCount / WorkFlowTypeAllArivalCount) == false)) {
                this.WorkFlowTypePercentage = (WorkFlowTypeYesArrivalCount / WorkFlowTypeAllArivalCount) * 100;
                this.WorkFlowTypePercentage = Math.round(this.WorkFlowTypePercentage);
              }
            }
          }
          else{
            this.showProgressSpinner = false;
            this.improveSearchLoader = false;
            this.isShow = false;
            // this.noRecordFoundDataBool = true;
          }
          },
          error: (err: any) => { },
        })
      );
      let sMonth: any;
      let fullMonth: any;
      let sYear: any;
      if (this.SelectedReportType == "monthly") {
        sMonth = this.datePipe.transform(this.Month, 'MM');
        fullMonth = this.datePipe.transform(this.Month, 'MMMM');
        sYear = this.datePipe.transform(this.Month, 'yyyy');
        year = sYear;
        this.cumulativeYear = this.datePipe.transform(this.Month, 'yyyy');
        this.pastcumulativeYear = Number(this.cumulativeYear) - 1;
        this.monthYear = fullMonth.concat(', ').concat(sYear);
      }
      else if (this.SelectedReportType == "quarterly") {
        sMonth = this.datePipe.transform(this.YearQuarter, 'MM');
        sYear = this.datePipe.transform(this.YearQuarter, 'yyyy');
        year = sYear;
        this.cumulativeYear = this.datePipe.transform(this.YearQuarter, 'yyyy');
        this.pastcumulativeYear = Number(this.cumulativeYear) - 1;
        this.monthYear = sMonth.concat(', ').concat(sYear);
      }

      let improveFacilityData = {
        Take: 10000,
        Skip: 0,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        Filter: {
          field: '',
          operator: '',
          value: this.filterVal,
          logic: '',
          filters: [],
        },
        searchString: this.filterVal,
        PageNumber: this.pageNumber,
        serviceType: [],
        data: {
          Facilities: facilityVal,
          System: systemVal,
          Regional: regionVal,
          fromMonth: `01/01/${this.SelectedReportType == "monthly" ? this.cumulativeYear : this.YearQuarter.getFullYear()}`,
          toMonth: `12/01/${this.cumulativeYear}`,
          selectedMonth: this.SelectedReportType == "quarterly" ? 0 : Number(sMonth),
          selectedQuarter: this.selectedQuarter,
          QualityGoalsData: null,
          ReportType: this.SelectedReportType,
          ReportTypeCum: "cumulative",
          PatientType: [],
          ActiveNonActiveFacility: this.active,
          FilterType: this.selectedFilterType,
          qag_time_frame: `${year}-1-1`,
          Status: this.analyzeService._statusValue,
          SpokeSiteFilter: this.spokeSite,
          PreArrival: 0
        },
      };

      this.subscription.push(
        this.improveService.GetImproveFacility(this.RoleName, this.UId, improveFacilityData).subscribe({
          next: (res: any) => {
            if((res.data.previous3MonthData != null && res.data.selectedMonthdata != null && this.SelectedReportType == "monthly") ||
            (res.data.previous3QuarterData != null && res.data.selectedQuarterdata != null && this.SelectedReportType == "quarterly")){
            this.getImproveData();
            this.isShow = true;
            this.noRecordFoundDataBool = false;
            if (this.SelectedReportType == "monthly") {

              this.YearQuarter = '';
              this.sMonth = sMonth;
              this.monthYearForLabel = this.datePipe.transform(this.Month, 'yyyy');
              if (sMonth == '01' || sMonth == '02') {
                this.monthYearForPreviousLabel = this.monthYearForLabel - 1;
              }
              
              this.FilterDashboardImproveList = res.data.previous3MonthData.data.slice(0, 22)
              res.data.selectedMonthdata.data.splice(10, 1)
              this.FilterDashboardImproveSelectedMonthList = res.data.selectedMonthdata.data.slice(0, 21)
              this.FilterDashboardImproveList.forEach((element: any) => {
                let obj: any = {};
                let Akeys = Object.keys(element);
                for (let key of Akeys) {
                  obj[key + 'R'] = element[key]
                  key += 'R';
                }
                this.FilterDashboardImproveListReplica.push(obj)
              });
            } else if (this.SelectedReportType == "quarterly") {
              this.Month = '';

              this.FilterDashboardImproveList = res.data.previous3QuarterData.data.slice(0, 22);
              res.data.selectedQuarterdata.data.splice(10, 1)
              this.FilterDashboardImproveList.forEach((item: any) => {

                if (this.selectedQuarter === 'quarter4') {
                  item['Quarter4'] = item['Quarter3'] || null;
                  item['Quarter3'] = item['Quarter2'] || null;
                  item['Quarter2'] = item['Quarter1'] || null;
                  item['Quarter1'] = null
                  item['QuarterGoals4'] = item['QuarterGoals3'] || null;
                  item['QuarterGoals3'] = item['QuarterGoals2'] || null;
                  item['QuarterGoals2'] = item['QuarterGoals1'] || null;
                  item['QuarterGoals1'] = null
                  this.quarterYearForLabel = this.cumulativeYear;
                }
                else if (this.selectedQuarter === 'quarter3') {
                  item['Quarter4'] = null
                  item['QuarterGoals4'] = null
                  this.quarterYearForLabel = this.cumulativeYear;
                }
                else if (this.selectedQuarter === 'quarter2') {
                  const temp = item['Quarter2'];
                  const tempQ1 = item['Quarter1'];
                  item['Quarter2'] = item['Quarter3'] || null;
                  item['Quarter1'] = temp || null;
                  item['Quarter4'] = tempQ1 || null;
                  item['Quarter3'] = null;
                  const tempGoal = item['QuarterGoals2'];
                  const tempGoalQ1 = item['QuarterGoals1'];
                  item['QuarterGoals2'] = item['QuarterGoals3'] || null;
                  item['QuarterGoals1'] = tempGoal || null;
                  item['QuarterGoals4'] = tempGoalQ1 || null;
                  item['QuarterGoals3'] = null;
                  this.quarterYearForLabel = this.cumulativeYear;
                  this.quarterYearForPreviousLabel = this.cumulativeYear - 1;
                }
                else if (this.selectedQuarter === 'quarter1') {
                  const temp = item['Quarter1'];
                  item['Quarter1'] = item['Quarter3'] || null;
                  item['Quarter4'] = item['Quarter2'] || null;
                  item['Quarter3'] = temp || null;
                  item['Quarter2'] = null;

                  const tempGoal = item['QuarterGoals1'];
                  item['QuarterGoals1'] = item['QuarterGoals3'] || null;
                  item['QuarterGoals4'] = item['QuarterGoals2'] || null;
                  item['QuarterGoals3'] = tempGoal || null;
                  item['QuarterGoals2'] = null;
                  this.quarterYearForLabel = this.cumulativeYear;
                  this.quarterYearForPreviousLabel = this.cumulativeYear - 1;
                }
              });

              this.FilterDashboardImproveSelectedMonthList = res.data.selectedQuarterdata.data.slice(0, 21);
              this.FilterDashboardImproveList.forEach((element: any) => {
                let obj: any = {};
                let Akeys = Object.keys(element);
                for (let key of Akeys) {
                  obj[key + 'R'] = element[key]
                  key += 'R';
                }
                this.FilterDashboardImproveListReplica.push(obj)
              });
            }
            this.FilterDashboardImproveListReplica.forEach((element: any, index: any) => {
              for (const item in element) {
                if (element[item] != null && !(item == 'QualityMetrics') && !(item == 'id') && !(item == 'fac_key')) {
                  element[item] = parseInt(element[item]);
                }
              }
            });
            if (this.SelectedReportType == 'monthly') {
              this.FilterDashboardImproveList.forEach((element: any, index: any) => {
                element.JanDataR = this.FilterDashboardImproveListReplica[index].JanDataR;
                element.JanGoalsR = this.FilterDashboardImproveListReplica[index].JanGoalsR;
                element.FebDataR = this.FilterDashboardImproveListReplica[index].FebDataR;
                element.FebGoalsR = this.FilterDashboardImproveListReplica[index].FebGoalsR;
                element.MarDataR = this.FilterDashboardImproveListReplica[index].MarDataR;
                element.MarGoalsR = this.FilterDashboardImproveListReplica[index].MarGoalsR;
                element.AprDataR = this.FilterDashboardImproveListReplica[index].AprDataR;
                element.AprGoalsR = this.FilterDashboardImproveListReplica[index].AprGoalsR;
                element.MayDataR = this.FilterDashboardImproveListReplica[index].MayDataR;
                element.MayGoalsR = this.FilterDashboardImproveListReplica[index].MayGoalsR;
                element.JunDataR = this.FilterDashboardImproveListReplica[index].JunDataR;
                element.JunGoalsR = this.FilterDashboardImproveListReplica[index].JunGoalsR;
                element.JulDataR = this.FilterDashboardImproveListReplica[index].JulDataR;
                element.JulGoalsR = this.FilterDashboardImproveListReplica[index].JulGoalsR;
                element.AugDataR = this.FilterDashboardImproveListReplica[index].AugDataR;
                element.AugGoalsR = this.FilterDashboardImproveListReplica[index].AugGoalsR;
                element.SepDataR = this.FilterDashboardImproveListReplica[index].SepDataR;
                element.SepGoalsR = this.FilterDashboardImproveListReplica[index].SepGoalsR;
                element.OctDataR = this.FilterDashboardImproveListReplica[index].OctDataR
                element.OctGoalsR = this.FilterDashboardImproveListReplica[index].OctGoalsR;
                element.NovDataR = this.FilterDashboardImproveListReplica[index].NovDataR;
                element.NovGoalsR = this.FilterDashboardImproveListReplica[index].NovGoalsR;
                element.DecDataR = this.FilterDashboardImproveListReplica[index].DecDataR;
                element.DecGoalsR = this.FilterDashboardImproveListReplica[index].DecGoalsR;
              });
            }
            else {
              this.FilterDashboardImproveList.forEach((element: any, index: any) => {
                element.Quarter1R = this.FilterDashboardImproveListReplica[index].Quarter1R;
                element.QuarterGoals1R = this.FilterDashboardImproveListReplica[index].QuarterGoals1R;
                element.Quarter2R = this.FilterDashboardImproveListReplica[index].Quarter2R;
                element.QuarterGoals2R = this.FilterDashboardImproveListReplica[index].QuarterGoals2R;
                element.Quarter3R = this.FilterDashboardImproveListReplica[index].Quarter3R;
                element.QuarterGoals3R = this.FilterDashboardImproveListReplica[index].QuarterGoals3R;
                element.Quarter4R = this.FilterDashboardImproveListReplica[index].Quarter4R;
                element.QuarterGoals4R = this.FilterDashboardImproveListReplica[index].QuarterGoals4R;
              });
            }
            this.basedOnMonth = this.datePipe.transform(this.Month, 'MM');
            this.basedOnMonth = this.datePipe.transform(this.Month, 'MM');
            this.basedOnMonth = this.datePipe.transform(this.Month, 'MM');
            let sltMnth: any = this.datePipe.transform(this.Month, 'MM/dd/yyyy');
            let date = new Date(sltMnth);
            if (this.SelectedReportType == 'quarterly') {
              this.longMonthOrYear = this.datePipe.transform(this.YearQuarter, 'yyyy');
            }
            else {
              this.longMonthOrYear = this.datePipe.transform(this.Month, 'MMMM, yyyy');
            }
            var quarter: any;
            if (this.SelectedReportType == 'quarterly') {
              switch (this.selectedQuarter) {
                case 'quarter1':
                  quarter = 'Quarter 1'
                  break;
                case 'quarter2':
                  quarter = 'Quarter 2'
                  break;
                case 'quarter3':
                  quarter = 'Quarter 3'
                  break;
                case 'quarter4':
                  quarter = 'Quarter 4'
                  break;
              }
            }
            this.headingSummaryOportunity = `Summary of Opportunities for ${this.SelectedReportType == 'quarterly' ? `${quarter},` : 'month of '} ${this.longMonthOrYear} at ${this.selectedOptionText}`;
            this.headingSummaryOportunityTemp = `Summary of Opportunities for ${this.SelectedReportType == 'quarterly' ? `${quarter},` : 'month of '} ${this.longMonthOrYear} at ${this.selectedOptionText}`;

            this.FilterDashboardImproveSelectedMonthList.forEach((element: any, index: any) => {
              if (element.QualityMetrics == '% 10 Min or Less Activation (EMS)') {
                this.FilterDashboardImproveSelectedMonthList[index].QualityMetrics = 'Activation by EMS at 10 minutes or less';
              }
              if (element.QualityMetrics == '% 10 Min or Less Activation (PV)') {
                this.FilterDashboardImproveSelectedMonthList[index].QualityMetrics = 'Activation by PV at 10 minutes or less';
              }
            });
            let FilterDashboardImproveListReplica: any = []
            this.FilterDashboardImproveList.forEach((element: any) => {
              switch (element.QualityMetrics) {
                case "Door to TS Notification Avg Minutes": element.QualityMetrics = "Door to Notification Mean (Min:Sec)"; break;
                case "Door to TS Notification Median Min": element.QualityMetrics = "Door to Notification Median (Min:Sec)"; break;
                case "Activation to Assessment Avg Mins": element.QualityMetrics = "Activation to Assessment Mean (Min:Sec)"; break;
                case "Activation to Assessment Median Mins": element.QualityMetrics = "Activation to Assessment Median (Min:Sec)"; break;
                case "Assessment to Thrombolytic Decision-making Avg Mins": element.QualityMetrics = "Assessment to Thrombolytic Decision Mean (Min:Sec)"; break;
                case "Assessment to Thrombolytic Decision-making Median Mins": element.QualityMetrics = "Assessment to Thrombolytic Decision Median (Min:Sec)"; break;
                case "Thrombolytic Medical Decision to Admin Avg Minutes": element.QualityMetrics = "Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)"; break;
                case "Thrombolytic Decision Making to Admin Median Mins": element.QualityMetrics = "Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)"; break;
                case "DTN Less or Equal 30 Minutes %": element.QualityMetrics = "DTN equal to or less than 30 minutes (%)"; break;
                case "DTN Less or Equal 45 Minutes %": element.QualityMetrics = "DTN equal to or less than 45 minutes (%)"; break;
                case "DTN Less or Equal 60 Minutes %": element.QualityMetrics = "DTN equal to or less than 60 minutes (%)"; break;
                case "TS Notification to Initial Response Avg Minutes": element.QualityMetrics = "TS Notification to Initial Response Mean Min"; break;
                case "Door to Needle Average (min:sec)": element.QualityMetrics = "Door to Needle Mean (Min:Sec)"; break;
                case "Door to Needle Median (min:sec)": element.QualityMetrics = "Door to Needle Median (Min:Sec)"; break;
              }
            });

            this.bodyFacilityImprovefacilityList = [];
            this.headerFacilityImprovefacilityList = [];
            this.IsEmsOrInPatientBoolNewObj = [];
            let selectedDate = new Date(this.Month);
            let BeforeSeletedDateForData = new Date(this.Month);
            let BeforeSeletedDateForHeader = new Date(this.Month);
            var firstIndexOfFilterDashboardImproveList = Object.assign({}, this.FilterDashboardImproveList[0]);
            this.headerFacilityImprovefacilityList = this.SortByNameListForExcel(firstIndexOfFilterDashboardImproveList, this.NameListforData(new Date(BeforeSeletedDateForHeader.setMonth(selectedDate.getMonth() - 2)), selectedDate, 'header'), 'header');
            let IsEmsOrInPatientBoolData = this.FilterDashboardImproveList.splice(10, 1)[0];
            for (let key of this.headerFacilityImprovefacilityList) {
              if(key.includes('Cumulative ')){
                key = 'pastCumulative'
              }
              if (IsEmsOrInPatientBoolData.hasOwnProperty(key)) {
                this.IsEmsOrInPatientBoolNewObj.push(IsEmsOrInPatientBoolData[key]);
              }
          }
            this.FilterDashboardImproveList.forEach((element: any) => {
              this.bodyFacilityImprovefacilityList.push(this.SortByNameListForExcel(element, this.NameListforData(new Date(BeforeSeletedDateForData.setMonth(selectedDate.getMonth() - 2)), selectedDate, 'data'), 'data'));
            })

            this.stylesForData1 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.data1) || val[0]?.data1 === '-1%');
            this.stylesForData2 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.data2) || val[0]?.data2 === '-1%');
            this.stylesForData3 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.data3) || val[0]?.data3 === '-1%');
            this.stylesForCumlative1 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.cumlative1) || val[0]?.cumlative1 === '-1%');
            this.stylesForCumlative2 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.cumlative2) || val[0]?.cumlative2 === '-1%');
            this.boolForThrombolytic = false;
            this.administratedCheckData1Bool = false;
            this.administratedCheckData2Bool = false;
            this.administratedCheckData3Bool = false;
            this.administratedCheckComulative1Bool = false;
            this.administratedCheckComulative2Bool = false;
            
            this.IsEmsOrInPatData1Bool = false;
            this.IsEmsOrInPatData2Bool = false;
            this.IsEmsOrInPatData3Bool = false;
            this.IsEmsOrInPatComulative1Bool = false;
            this.IsEmsOrInPatComulative2Bool = false;

            if(this.stylesForData1.length === 21){
              this.bodyFacilityImprovefacilityList.forEach((val:any) => {
                val[0].data1 = '';
              });
            }
            if(this.stylesForData2.length === 21){
              this.bodyFacilityImprovefacilityList.forEach((val:any) => {
                val[0].data2 = '';
              });
            }
            if(this.stylesForData3.length === 21){
              this.bodyFacilityImprovefacilityList.forEach((val:any) => {
                val[0].data3 = '';
              });
            }
            if(this.stylesForCumlative1.length === 21){
              this.bodyFacilityImprovefacilityList.forEach((val:any) => {
                val[0].cumlative1 = '';
              });
            }
            if(this.stylesForCumlative2.length === 21){
              this.bodyFacilityImprovefacilityList.forEach((val:any) => {
                val[0].cumlative2 = '';
              });
            };
            const clearDataByQuality = (stylesForData:any, dataNumber:any, type:any) => {
              this.bodyFacilityImprovefacilityList.forEach((val:any) => {
                if (type === 'data') {
                  if ((val[0]?.quality === '% 10 Min or Less Activation (EMS)' || val[0]?.quality === '% 10 Min or Less Activation (PV)') && val[0]['data' + dataNumber] === '-1%') {
                      val[0]['data' + dataNumber] = '';
                  }
              }
                if (type === 'comulative') {
                  if ((val[0]?.quality === '% 10 Min or Less Activation (EMS)' || val[0]?.quality === '% 10 Min or Less Activation (PV)') && val[0]['cumlative1'] === '-1%') {
                      val[0]['cumlative1'] = '';
                  }
                  if ((val[0]?.quality === '% 10 Min or Less Activation (EMS)' || val[0]?.quality === '% 10 Min or Less Activation (PV)') && val[0]['cumlative2'] === '-1%') {
                      val[0]['cumlative2'] = '';
                  }
              }

                  if (
                        val[0]?.quality === 'Door to Needle Mean (Min:Sec)' ||
                        val[0]?.quality === 'Door to Needle Median (Min:Sec)' ||
                        val[0]?.quality === 'Activation to Needle Mean' ||
                        val[0]?.quality === 'Activation to Needle Median' ||
                        val[0]?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' ||
                        val[0]?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
                        val[0]?.quality === 'DTN equal to or less than 30 minutes (%)' ||
                        val[0]?.quality === 'DTN equal to or less than 45 minutes (%)' ||
                        val[0]?.quality === 'DTN equal to or less than 60 minutes (%)'
                    ){
                      if(type === 'data'){
                      if(this.bodyFacilityImprovefacilityList[9][0]['data' + dataNumber] === '0'){
                        val[0]['data' + dataNumber] = '';
                      }
                    }
                      if(type === 'comulative'){
                        if(this.bodyFacilityImprovefacilityList[9][0]['cumlative' + dataNumber] === '0'){
                          val[0]['cumlative' + dataNumber] = '';
                        }
                      }

                    } 

                  if (val[0]?.quality === 'Door to Needle Mean (Min:Sec)' ||
                  val[0]?.quality === 'Door to Needle Median (Min:Sec)' ||
                  val[0]?.quality === 'DTN equal to or less than 30 minutes (%)' ||
                  val[0]?.quality === 'DTN equal to or less than 45 minutes (%)' ||
                  val[0]?.quality === 'DTN equal to or less than 60 minutes (%)') 
                  {
                    if(type === 'data'){
                    if (this.IsEmsOrInPatientBoolNewObj[dataNumber] === 'False' && this.bodyFacilityImprovefacilityList[9][0]['data' + dataNumber] !== '0') {
                      val[0]['data' + dataNumber] = '';
                    }
                  }
                    if(type === 'comulative'){
                     if(this.IsEmsOrInPatientBoolNewObj[4] === 'False' && this.bodyFacilityImprovefacilityList[9][0]['cumlative1'] !== '0'){
                      val[0]['cumlative1'] = '';
                    }
                     if(this.IsEmsOrInPatientBoolNewObj[5] === 'False' && this.bodyFacilityImprovefacilityList[9][0]['cumlative2'] !== '0'){
                      val[0]['cumlative2'] = '';
                    }
                   }
                  }

              });
          }
          
          if (this.stylesForData1.length < 21 ) {
              clearDataByQuality.call(this, this.stylesForData1, 1, 'data');
          }
          
          if (this.stylesForData2.length < 21) {
              clearDataByQuality.call(this, this.stylesForData2, 2, 'data');
          }
          
          if (this.stylesForData3.length < 21) {
              clearDataByQuality.call(this, this.stylesForData3, 3, 'data');
          }
          
          if (this.stylesForCumlative1.length < 21) {
              clearDataByQuality.call(this, this.stylesForCumlative1, 1, 'comulative');
          }
          
          if (this.stylesForCumlative2.length < 21) {
              clearDataByQuality.call(this, this.stylesForCumlative2, 2, 'comulative');
          }
          
            this.headerFacilityImprovefacilityList.forEach((element: any, index: any) => {
              if (element == 'Cumulative') { this.headerFacilityImprovefacilityList[index] = `Cumulative ${this.cumulativeYear}` }
              if (element == 'QualityMetrics') { this.headerFacilityImprovefacilityList[index] = 'Quality Metrics' }
              else if (element.includes('Data')) { this.headerFacilityImprovefacilityList[index] = element.slice(0, 3) + ' ' + 'Data' }
              else if (!element.includes('Quarter') && element.includes('Goals')) { this.headerFacilityImprovefacilityList[index] = element.slice(0, 3) + ' ' + 'Goals' }
              else if (element.includes('QuarterGoals')) {
                switch (this.headerFacilityImprovefacilityList[3]) {
                  case 'Quarter 1': this.headerFacilityImprovefacilityList[index] = 'Q1 Goals'; break;
                  case 'Quarter 2': this.headerFacilityImprovefacilityList[index] = 'Q2 Goals'; break;
                  case 'Quarter 3': this.headerFacilityImprovefacilityList[index] = 'Q3 Goals'; break;
                  case 'Quarter 4': this.headerFacilityImprovefacilityList[index] = 'Q4 Goals'; break;
                }
              }
              else if (element.includes('Quarter') && !element.includes('Goals')) { this.headerFacilityImprovefacilityList[index] = element.slice(0, 7) + ' ' + element.slice(-1) }
            });
            this.FilterDashboardImproveSelectedMonthList.forEach((element: any) => {
              let obj: any = {}
              let Akeys = Object.keys(element);
              for (let key of Akeys) {
                obj[key] = element[key]
              }
              FilterDashboardImproveListReplica.push(obj);
            })


            let i;
            for (i = 0; i < FilterDashboardImproveListReplica.length; i++) {
              if (FilterDashboardImproveListReplica[i].JanData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['JanData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['JanData']) : Number(FilterDashboardImproveListReplica[i]['JanData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['JanData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].JanData;
              }
              if (FilterDashboardImproveListReplica[i].JanGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['JanGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['JanGoals']);
                delete FilterDashboardImproveListReplica[i].JanGoals;
              }
              if (FilterDashboardImproveListReplica[i].FebData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['FebData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['FebData']) : Number(FilterDashboardImproveListReplica[i]['FebData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['FebData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].FebData;
              }
              if (FilterDashboardImproveListReplica[i].FebGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['FebGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['FebGoals']);
                delete FilterDashboardImproveListReplica[i].FebGoals;
              }
              if (FilterDashboardImproveListReplica[i].MarData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['MarData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['MarData']) : Number(FilterDashboardImproveListReplica[i]['MarData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['MarData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].MarData;
              }
              if (FilterDashboardImproveListReplica[i].MarGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['MarGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['MarGoals']);
                delete FilterDashboardImproveListReplica[i].MarGoals;
              }
              if (FilterDashboardImproveListReplica[i].AprData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['AprData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['AprData']) : Number(FilterDashboardImproveListReplica[i]['AprData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['AprData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].AprData;
              }
              if (FilterDashboardImproveListReplica[i].AprGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['AprGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['AprGoals']);
                delete FilterDashboardImproveListReplica[i].AprGoals;
              }
              if (FilterDashboardImproveListReplica[i].MayData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['MayData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['MayData']) : Number(FilterDashboardImproveListReplica[i]['MayData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['MayData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].MayData;
              }
              if (FilterDashboardImproveListReplica[i].MayGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['MayGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['MayGoals']);
                delete FilterDashboardImproveListReplica[i].MayGoals;
              }
              if (FilterDashboardImproveListReplica[i].JunData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['JunData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['JunData']) : Number(FilterDashboardImproveListReplica[i]['JunData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['JunData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].JunData;
              }
              if (FilterDashboardImproveListReplica[i].JunGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['JunGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['JunGoals']);
                delete FilterDashboardImproveListReplica[i].JunGoals;
              }
              if (FilterDashboardImproveListReplica[i].JulData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['JulData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['JulData']) : Number(FilterDashboardImproveListReplica[i]['JulData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['JulData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].JulData;
              }
              if (FilterDashboardImproveListReplica[i].JulGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['JulGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['JulGoals']);
                delete FilterDashboardImproveListReplica[i].JulGoals;
              }
              if (FilterDashboardImproveListReplica[i].AugData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['AugData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['AugData']) : Number(FilterDashboardImproveListReplica[i]['AugData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['AugData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].AugData;
              }
              if (FilterDashboardImproveListReplica[i].AugGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['AugGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['AugGoals']);
                delete FilterDashboardImproveListReplica[i].AugGoals;
              }
              if (FilterDashboardImproveListReplica[i].SepData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['SepData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['SepData']) : Number(FilterDashboardImproveListReplica[i]['SepData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['SepData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].SepData;
              }
              if (FilterDashboardImproveListReplica[i].SepGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['SepGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['SepGoals']);
                delete FilterDashboardImproveListReplica[i].SepGoals;
              }
              if (FilterDashboardImproveListReplica[i].OctData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['OctData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['OctData']) : Number(FilterDashboardImproveListReplica[i]['OctData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['OctData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].OctData;
              }
              if (FilterDashboardImproveListReplica[i].OctGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['OctGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['OctGoals']);
                delete FilterDashboardImproveListReplica[i].OctGoals;
              }
              if (FilterDashboardImproveListReplica[i].NovData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['NovData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['NovData']) : Number(FilterDashboardImproveListReplica[i]['NovData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['NovData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].NovData;
              }
              if (FilterDashboardImproveListReplica[i].NovGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['NovGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['NovGoals']);
                delete FilterDashboardImproveListReplica[i].NovGoals;
              }
              if (FilterDashboardImproveListReplica[i].DecData != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['DecData'];
                FilterDashboardImproveListReplica[i].commonDataR =
                  FilterDashboardImproveListReplica[i].QualityMetrics.includes('%') ? parseInt(FilterDashboardImproveListReplica[i]['DecData']) : Number(FilterDashboardImproveListReplica[i]['DecData'].split(':')[0] + '.' + FilterDashboardImproveListReplica[i]['DecData'].split(':')[1]);
                delete FilterDashboardImproveListReplica[i].DecData;
              }
              if (FilterDashboardImproveListReplica[i].DecGoals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['DecGoals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['DecGoals']);
                delete FilterDashboardImproveListReplica[i].DecGoals;
              }
              if (FilterDashboardImproveListReplica[i].Quarter != null) {
                FilterDashboardImproveListReplica[i].commonData = FilterDashboardImproveListReplica[i]['Quarter'];
                FilterDashboardImproveListReplica[i].commonDataR = parseInt(FilterDashboardImproveListReplica[i]['Quarter']);
                delete FilterDashboardImproveListReplica[i].Quarter;
              }
              if (FilterDashboardImproveListReplica[i].goals != null) {
                FilterDashboardImproveListReplica[i].commonGoals = FilterDashboardImproveListReplica[i]['goals'];
                FilterDashboardImproveListReplica[i].commonGoalsR = parseInt(FilterDashboardImproveListReplica[i]['goals']);
                delete FilterDashboardImproveListReplica[i].goals;
              }

            }


            FilterDashboardImproveListReplica.forEach((element: any) => {
              switch (element.QualityMetrics) {
                case "Door to TS Notification Avg Minutes": element.QualityMetrics = "Door to Notification Mean (Min:Sec)"; break;
                case "Door to TS Notification Median Min": element.QualityMetrics = "Door to Notification Median (Min:Sec)"; break;
                case "Activation to Assessment Avg Mins": element.QualityMetrics = "Activation to Assessment Mean (Min:Sec)"; break;
                case "Activation to Assessment Median Mins": element.QualityMetrics = "Activation to Assessment Median (Min:Sec)"; break;
                case "Assessment to Thrombolytic Decision-making Avg Mins": element.QualityMetrics = "Assessment to Thrombolytic Decision Mean (Min:Sec)"; break;
                case "Assessment to Thrombolytic Decision-making Median Mins": element.QualityMetrics = "Assessment to Thrombolytic Decision Median (Min:Sec)"; break;
                case "Thrombolytic Medical Decision to Admin Avg Minutes": element.QualityMetrics = "Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)"; break;
                case "Thrombolytic Decision Making to Admin Median Mins": element.QualityMetrics = "Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)"; break;
                case "DTN Less or Equal 30 Minutes %": element.QualityMetrics = "DTN equal to or less than 30 minutes (%)"; break;
                case "DTN Less or Equal 45 Minutes %": element.QualityMetrics = "DTN equal to or less than 45 minutes (%)"; break;
                case "DTN Less or Equal 60 Minutes %": element.QualityMetrics = "DTN equal to or less than 60 minutes (%)"; break;
                case "TS Notification to Initial Response Avg Minutes": element.QualityMetrics = "TS Notification to Initial Response Mean Min"; break;
                case "Door to Needle Average (min:sec)": element.QualityMetrics = "Door to Needle Mean (Min:Sec)"; break;
                case "Door to Needle Median (min:sec)": element.QualityMetrics = "Door to Needle Median (Min:Sec)"; break;
              }
            })

            this.improveAData = FilterDashboardImproveListReplica.slice(1, 5);
            this.improveNData = FilterDashboardImproveListReplica.slice(5, 7);
            this.improveAAData = FilterDashboardImproveListReplica.slice(7, 9);
            this.improveAHAAHASFL = FilterDashboardImproveListReplica.slice(9, 12);
            this.activationToNeedleArray = FilterDashboardImproveListReplica.slice(12, 14);
            this.improveATData = FilterDashboardImproveListReplica.slice(14, 16);
            this.improveTAMHATS = FilterDashboardImproveListReplica.slice(16, 18);
            this.improveAHAAHASFL2 = FilterDashboardImproveListReplica.slice(18, 21);

            this.improveAData.forEach((element: any, index: any) => {
              if (element.QualityMetrics.includes('Avg')) {
                this.improveAData[index].QualityMetrics = `Door to Notification <b>Avg</b> Minutes`
              }
              else if (element.QualityMetrics.includes('Median')) {
                this.improveAData[index].QualityMetrics = `Door to Notification Median Min`
              }
              if((element.QualityMetrics === 'Activation by EMS at 10 minutes or less' || element.QualityMetrics === 'Activation by PV at 10 minutes or less') && element.commonData === "-1%"){
                element.commonData = "0%";
              }
            });
            this.improveAAData.forEach((element: any, index: any) => {
              if (element.QualityMetrics.includes('Avg')) {
                this.improveAAData[index].QualityMetrics = `TS Notification to Initial Response <b>Avg</b> Minute`
              }
              else if (element.QualityMetrics.includes('Median')) {
                this.improveAAData[index].QualityMetrics = `TS Notification to Initial Response Median Min`
              }
              if (element.QualityMetrics.includes('TS Notification to Initial Response Mean Minutes')) {
                this.improveAAData[index].QualityMetrics = `TS Notification to Initial Response Mean Min`
              }
            });
            this.improveNData.forEach((element: any, index: any) => {
              if (element.QualityMetrics.includes('Avg')) {
                this.improveNData[index].QualityMetrics = `Activation to Assessment <b>Avg</b> Mins`
              }
              else if (element.QualityMetrics.includes('Median')) {
                this.improveNData[index].QualityMetrics = `Activation to Assessment Median Min`
              }
            });
            
          }
          else{
            this.showProgressSpinner = false;
            this.isShow = false;
            this.noRecordFoundDataBool = true;
            this.improveSearchLoader = false;
          }
        }
        })
      );


      const accessData = this.accessControlService.checkAccess( MenuItemsAccess.PiReportsRead, MenuItemsAccess.PiReportsReadWrite);
      this.isAccessRead = accessData.isAccessRead;
      this.isAccessReadWrite = accessData.isAccessReadWrite;

      this.getFacilityDashboardAllCharts();
      this.getAllPieChartsData();
    } else {
      if (this.selectedFilterType == null) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Plese select Filter Type first.',
        });
        this.filterTypeErrorBool = true;
        setTimeout(() => {
          this.filterTypeErrorBool = false;
        }, 1000);
        return;
      }

      if (this.selectFacilityPIOptions == null) {
        let facilitysystem: any;
        if (this.event == 'facility') {
          facilitysystem = 'Facility';
        } else if(this.event == 'system')  {
          facilitysystem = 'System';
        } else  {
          facilitysystem = 'Regional';
        }
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: `Plese select ${facilitysystem} first.`,
        });
        this.facilityErrorBool = true;
        setTimeout(() => {
          this.facilityErrorBool = false;
        }, 1000);
        return;
      }

      if (this.selectFacilityPIOptions == null) {
        let monthquarter: any;
        if (this.event == 'facility') {
          monthquarter = 'Month'
        } else {
          monthquarter = 'Quarter'
        }
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: `Plese select ${monthquarter} first.`,
        });
        this.facilityErrorBool = true;
        setTimeout(() => {
          this.facilityErrorBool = false;
        }, 1000);
        return;
      }

      if (this.SelectedReportType == null) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Plese select Report Type first.',
        });
        this.reportTypeErrorBool = true;
        setTimeout(() => {
          this.reportTypeErrorBool = false;
        }, 1000);
        return;
      }

      if (this.SelectedReportType == 'monthly' && this.Month == "") {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Plese select Month first.',
        });
        this.monthErrorBool = true;
        setTimeout(() => {
          this.monthErrorBool = false;
        }, 1000);
        return;
      }

      if (this.SelectedReportType == 'quarterly' && this.YearQuarter == "") {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Plese select year first.',
        });
        this.yearErrorBool = true;
        setTimeout(() => {
          this.yearErrorBool = false;
        }, 1000);
        return;
      }
      if (this.SelectedReportType == 'quarterly' && this.YearQuarter != "" && this.selectedQuarter == '') {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Plese select Quarter first.',
        });
        this.quarterErrorBool = true;
        setTimeout(() => {
          this.quarterErrorBool = false;
        }, 1000);
        return;
      }
    }
  }

  CalculateMeanMedian(timeCasesMean: any, totalRecords: any, timeList: any, caseType: any, forCase: any) {
    //Mean 
    timeCasesMean /= totalRecords;
    timeCasesMean = Math.round(timeCasesMean);

    //Median
    let timeSortCases = timeList.sort(function (a: any, b: any) { return a.AssessmentTimeInterval - b.AssessmentTimeInterval });
    let timeCaseMid = Math.round(Number(totalRecords) / 2);
    if ((timeCaseMid % 2 != 0 && timeCaseMid != 1) || Number(totalRecords) == 2) {
      this.timeCasesMedian = Number(timeSortCases[timeCaseMid - 1]?.AssessmentTimeInterval) + Number(timeSortCases[timeCaseMid]?.AssessmentTimeInterval);
      this.timeCasesMedian = Math.round(this.timeCasesMedian / 2);
    }
    else {
      timeCaseMid = Math.round(timeCaseMid);
      this.timeCasesMedian = Number(timeSortCases[timeCaseMid - 1]?.AssessmentTimeInterval);
    }
    //Maximum
    this.timeCasesMaximum = Number(timeList[totalRecords - 1]?.AssessmentTimeInterval);

    switch (true) {
      //For Case Assesment
      case caseType == 'inpatient' && forCase == 'assesment':
        this.assessmentInpatientTimeCasesMean = timeCasesMean;

        this.assessmentInpatientTimeCasesMedian = this.timeCasesMedian;
        this.assessmentInpatientTimeCasesMaximum = this.timeCasesMaximum;
        break;
      case caseType == 'triage' && forCase == 'assesment':
        this.assessmentTriageTimeCasesMean = timeCasesMean;

        this.assessmentTriageTimeCasesMedian = this.timeCasesMedian;
        this.assessmentTriageTimeCasesMaximum = this.timeCasesMaximum;
        break;
      case caseType == 'edonset' && forCase == 'assesment':
        this.assessmentEDOnsetTimeCasesMean = timeCasesMean;

        this.assessmentEDOnsetTimeCasesMedian = this.timeCasesMedian;
        this.assessmentEDOnsetTimeCasesMaximum = this.timeCasesMaximum;
        break;
      //For Case thrombolyticDecision
      case caseType == 'inpatient' && forCase == 'thrombolyticDecision':
        this.thrombolyticDecisionInpatientTimeCasesMean = timeCasesMean;

        this.thrombolyticDecisionInpatientTimeCasesMedian = this.timeCasesMedian;
        this.thrombolyticDecisionInpatientTimeCasesMaximum = this.timeCasesMaximum;
        break;
      case caseType == 'triage' && forCase == 'thrombolyticDecision':
        this.thrombolyticDecisionTriageTimeCasesMean = timeCasesMean;

        this.thrombolyticDecisionTriageTimeCasesMedian = this.timeCasesMedian;
        this.thrombolyticDecisionTriageTimeCasesMaximum = this.timeCasesMaximum;
        break;
      case caseType == 'edonset' && forCase == 'thrombolyticDecision':
        this.thrombolyticDecisionEDOnsetTimeCasesMean = timeCasesMean;

        this.thrombolyticDecisionEDOnsetTimeCasesMedian = this.timeCasesMedian;
        this.thrombolyticDecisionEDOnsetTimeCasesMaximum = this.timeCasesMaximum;
        break;
      //For Case thrombolyticAdministration
      case caseType == 'inpatient' && forCase == 'thrombolyticAdministration':
        this.thrombolyticAdministrationInpatientTimeCasesMean = timeCasesMean;

        this.thrombolyticAdministrationInpatientTimeCasesMedian = this.timeCasesMedian;
        this.thrombolyticAdministrationInpatientTimeCasesMaximum = this.timeCasesMaximum;
        break;
      case caseType == 'triage' && forCase == 'thrombolyticAdministration':
        this.thrombolyticAdministrationTriageTimeCasesMean = timeCasesMean;

        this.thrombolyticAdministrationTriageTimeCasesMedian = this.timeCasesMedian;
        this.thrombolyticAdministrationTriageTimeCasesMaximum = this.timeCasesMaximum;
        break;
      case caseType == 'edonset' && forCase == 'thrombolyticAdministration':
        this.thrombolyticAdministrationEDOnsetTimeCasesMean = timeCasesMean;

        this.thrombolyticAdministrationEDOnsetTimeCasesMedian = this.timeCasesMedian;
        this.thrombolyticAdministrationEDOnsetTimeCasesMaximum = this.timeCasesMaximum;
        break;

    }
  }

  headerFacilityImprovefacilityList: any = [];
  bodyFacilityImprovefacilityList: any = [];
  SortByNameListForExcel(arr: any, dataKeys: any, identifier: any) {
    let nameList = [];
    let Akeys = Object.keys(arr);
    for (let key of Akeys) {
      const quarterString = this.selectedQuarter.charAt(0).toUpperCase() + this.selectedQuarter.slice(1).slice(0, 6) + 'Goals' + this.selectedQuarter.slice(-1)
      const monthString = new Date(this.Month).toLocaleString('en-US', { month: 'short', year: 'numeric' }).substring(0, 3) + 'Goals';
      if (
        arr[key] === null ||
        key.includes('Goals') && !key.includes(quarterString) && this.selectedQuarter !== '' && identifier === 'header' ||
        key.includes('Goals') && !key.includes(monthString) && this.Month !== '' && identifier === 'header'   ||
         arr[key] === null && this.SelectedReportType == 'monthly' ||
         key === 'fac_key' ||
         key === 'id' ||
         key === 'WeeKLabel' ||
         key.includes('aR') ||
         key.includes('sR') ||
         key.includes('1R') ||
         key.includes('2R') ||
         key.includes('3R') ||
         key.includes('4R')
      ) {

        if( key.includes('Goals') && key.includes(monthString) && key !== monthString + 'R' && this.Month != '' && identifier == 'header'){
          nameList.push({ [key]: arr[key] });
        }
        if( key.includes('Goals') && key.includes(quarterString) && key !== quarterString && this.selectedQuarter != '' && identifier == 'header'){
          nameList.push({ [key]: 'Goals' });
        }
        
        delete arr[key];

      }
      else {
        if (key == 'Cumulative') {
          key = `Cumulative`;
        }
        else if (key == 'pastCumulative') {
          key = `Cumulative ${this.pastcumulativeYear}`
          arr[key] = arr['pastCumulative']
          delete arr['pastCumulative']
        }
        nameList.push({ [key]: arr[key] });
      }
    }
    const sortedReport = (a: any, b: any) => {
      const aIndex = dataKeys.indexOf(Object.keys(a)[0]);
      const bIndex = dataKeys.indexOf(Object.keys(b)[0]);

      if (aIndex < 0) {
        return 1;
      } else if (bIndex < 0) {
        return -1;
      } else {
        return aIndex - bIndex;
      }
    };
    nameList.sort(sortedReport);
    var dataSortedList: any = [];
    let sortedDataList = this.convertArrayToObject(nameList, identifier);
    if (identifier == 'data') {
      if (sortedDataList[0] == "THROMBOLYTIC ADMINISTERED #" || sortedDataList[0] == "Stroke Volume") {
        dataSortedList.push({ quality: sortedDataList[0], data1: sortedDataList[1], data2: sortedDataList[2], data3: sortedDataList[3], cumlative1: sortedDataList[4], cumlative2: sortedDataList[5] })
      }
      else if (sortedDataList[0].includes('%')) {
        dataSortedList.push({
          quality: sortedDataList[0], data1: sortedDataList[1], data2: sortedDataList[3], data3: sortedDataList[5], cumlative1: sortedDataList[7], cumlative2: sortedDataList[8],
          goals1: sortedDataList[2], goals2: sortedDataList[4], goals3: sortedDataList[6],  cumlative1R: parseInt(sortedDataList[7].split(':')[0]), data1R: parseInt(sortedDataList[1].split(':')[0]), data2R: parseInt(sortedDataList[3].split(':')[0]), data3R: parseInt(sortedDataList[5].split(':')[0]), goals1R: Number(sortedDataList[2]), goals2R: Number(sortedDataList[4]), goals3R: Number(sortedDataList[6])
        }) //goalsR: Number(sortedDataList[6])
      }
      else {
        dataSortedList.push({
          quality: sortedDataList[0], data1: sortedDataList[1], data2: sortedDataList[3], data3: sortedDataList[5], cumlative1: sortedDataList[7], cumlative2: sortedDataList[8],
          goals1: sortedDataList[2], goals2: sortedDataList[4], goals3: sortedDataList[6], cumlative1R: Number(sortedDataList[7].split(':')[0] + '.' + sortedDataList[7].split(':')[1]), data1R: Number(sortedDataList[1].split(':')[0] + '.' + sortedDataList[1].split(':')[1]), data2R: Number(sortedDataList[3].split(':')[0] + '.' + sortedDataList[3].split(':')[1]), data3R: Number(sortedDataList[5].split(':')[0] + '.' + sortedDataList[5].split(':')[1]), goals1R: Number(sortedDataList[2]), goals2R: Number(sortedDataList[4]), goals3R: Number(sortedDataList[6])
        }) //goalsR: Number(sortedDataList[6])
      }
    }
    else if (identifier == 'header') {
      return sortedDataList;
    }
    return dataSortedList;
  }

  convertArrayToObject(arr: any, identifier: any) {
    if (identifier == 'data') {
      let dataObj = arr.map((x: any) => {
        return Object.values(x)[0];
      })
      return dataObj;
    }
    else if (identifier == 'header') {
      let headerObj = arr.map((x: any) => {
        return Object.keys(x)[0];
      })
      return headerObj;
    }
  }

  NameListforData(startDate: any, endDate: any, identifier: any) {
    if (this.SelectedReportType == 'monthly') {
      let monthsList: any = [];
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const monthString = currentDate.toLocaleString('en-US', { month: 'short', year: 'numeric' }).substring(0, 3);
        monthsList.push(monthString + 'Data');
        identifier == 'data' ? monthsList.push(monthString + 'Goals') : '';
        currentDate.setMonth(currentDate.getMonth() + 1);
      }
      monthsList.push(`Cumulative`);
      monthsList.push(`Cumulative ${this.pastcumulativeYear}`);
      monthsList.unshift('QualityMetrics');
      return monthsList;
    }
    else if (this.SelectedReportType == 'quarterly') {
      let quarterList: any = [];
      for (let i = 0; i < this.FilterDashboardImproveList.length; i++) {
        quarterList = [];
        let arrNum: any = [];
        switch (Number(this.selectedQuarter.slice(-1))) {
          case 1: arrNum = [3, 4, 1]; break;
          case 2: arrNum = [4, 1, 2]; break;
          case 3: arrNum = [1, 2, 3]; break;
          case 4: arrNum = [2, 3, 4]; break;
        }
        arrNum.forEach((element: any) => {
          quarterList.push('Quarter' + element)
          identifier == 'data' ? quarterList.push('QuarterGoals' + element) : '';
        });
        quarterList.push(`Cumulative`);
        quarterList.push(`Cumulative ${this.pastcumulativeYear}`);
        quarterList.unshift('QualityMetrics');
        quarterList = quarterList.flat();
        break;
      }
      return quarterList;
    }
  }

  GenerateMonthlyReportText: string = "Generate Report";
  generateTemplate() {
    this.improveTemplate = '';
    this.improveFacilityTable = '';
    this.improveFacilityGraphs = '';
    this.improveRapidiMO = '';
    this.improveSummaryFacility = '';
    this.generateTemplatebool = true;
    this.showProgressSpinner = true;
    this.exportPdf();

    this.improveTemplate +=
      `<div id="templateEditor"><h2><b>Facility Dashboard Outliers Report</b></h2>`

    this.improveSummaryFacility += `
    <h3><b>${this.headingSummaryOportunityTemp}</b></h3>`;

    this.improveSummaryFacility +=
      `<ul>`
    this.improveAHAAHASFL.forEach((improvedata: any) => {
      this.improveSummaryFacility +=
        `<li><span class="closer">${improvedata.QualityMetrics} was at
      <b>${improvedata.commonData}</b>`;
      if (improvedata.commonGoals != null) {
        this.improveSummaryFacility += `<span>
        ${!(improvedata.commonData.includes('%')) ? '(goal of less than ' + improvedata.commonGoals + ')' : ' (goal of more than ' + improvedata.commonGoals + ')'}
        </span>`
      }
      this.improveSummaryFacility += `</span></li>
      `
    })
    this.improveAHAAHASFL2.forEach((improvedata: any) => {
      this.improveSummaryFacility +=
        `
      <li class="mb-3" >${improvedata.QualityMetrics} was at
      <b>${improvedata.commonData}</b>`;
      if (!(improvedata.commonData?.toString().includes('%'))) {
        this.improveSummaryFacility +=
          `<span> minutes</span>`
      };
      if (improvedata.commonGoals != null) {
        this.improveSummaryFacility +=
          `<span>
        ${!(improvedata.commonData.includes('%')) ? ' (goal of less than ' + improvedata.commonGoals + ')' : ' (goal of more than ' + improvedata.commonGoals + ')'}
        </span>`;
      }
      this.improveSummaryFacility += `</li>
      `
    });
    this.activationToNeedleArray.forEach((improvedata: any) => {
      this.improveSummaryFacility +=
        `
      <li class="mb-3" >${improvedata.QualityMetrics} was at
      <b>${improvedata.commonData}</b>`;
      if (!(improvedata.commonData?.toString().includes('%'))) {
        this.improveSummaryFacility +=
          `<span> minutes</span> </li>`
      };
    });
    this.improveSummaryFacility += `
      </ul>`

    this.improveSummaryFacility +=
      `<h3><b>Activation (measure of hospital activation of TS):</b></h3>`;
    this.improveAData.forEach((improvedata: any) => {

      this.improveSummaryFacility +=
        `<ul>
          <li class=" mb-3"><span>${improvedata.QualityMetrics}</span> was at
          <b>${improvedata.commonData}</b>`;
      if (!(improvedata.commonData?.toString()).includes('%')) {
        this.improveSummaryFacility += `
          <span> minutes</span>`
      }
      if (improvedata.commonGoals != null) {
        this.improveSummaryFacility +=
          `<span>
          ${!(improvedata.commonData.includes('%')) ? ' (goal of less than ' + improvedata.commonGoals + ')' : ' (goal of more than ' + improvedata.commonGoals + ')'}
          </span>`;
      }
      this.improveSummaryFacility += `</li>
        </ul>`
    });
    this.improveSummaryFacility +=
      `<h3><b>Notification to TS initial response (measure of TS response):</b></h3>`;
    this.improveAAData.forEach((improvedata: any) => {

      this.improveSummaryFacility +=
        `<ul>
          <li class="mb-3"><span>${improvedata.QualityMetrics}</span> was at
          <b>${improvedata.commonData}</b>`;
      if (!(improvedata.commonData?.toString()).includes('%')) {
        this.improveSummaryFacility +=
          `<span> minutes</span>`;
      };
      if (improvedata.commonGoals) {
        this.improveSummaryFacility +=
          `<span>
          ${!(improvedata.commonData.includes('%')) ? ' (goal of less than ' + improvedata.commonGoals + ')' : ' (goal of more than ' + improvedata.commonGoals + ')'}
          </span>`
      };
      this.improveSummaryFacility += `</li>
        </ul>`;
    });
    this.improveSummaryFacility +=
      `<h3><b>Activation to Assessment (measure of teleneurology ability to assess the <br>patient after activation):</b></h3>`;
    this.improveNData.forEach((improvedata: any) => {

      this.improveSummaryFacility +=
        `<ul>
          <li class="mb-3"><span>${improvedata.QualityMetrics}</span> was at
          <b>${improvedata.commonData}</b>`;
      if (!(improvedata.commonData?.toString()).includes('%')) {
        this.improveSummaryFacility +=
          `<span> minutes</span>`
      };
      if (improvedata.commonGoals) {
        this.improveSummaryFacility +=
          `<span>
         ${!(improvedata.commonData.includes('%')) ? ' (goal of less than ' + improvedata.commonGoals + ')' : ' (goal of more than ' + improvedata.commonGoals + ')'}
         </span>`
      };
      this.improveSummaryFacility += `</li>
        </ul>`;
    });

    this.improveSummaryFacility +=
      `<h3><b>Assessment to Thrombolytic Decision (measure of teams ability to obtain critical information for <br>decision and physicians decision to administer thrombolytic after all information is obtained for <br>decision :</b></h3>`;
    this.improveATData.forEach((improvedata: any) => {

      this.improveSummaryFacility +=
        `<ul>
          <li class="mb-3"><span>${improvedata.QualityMetrics}</span> was at
          <b>${improvedata.commonData}</b>`;
      if (!(improvedata.commonData?.toString()).includes('%')) {
        this.improveSummaryFacility +=
          `<span> minutes</span>`
      };
      if (improvedata.commonGoals) {
        this.improveSummaryFacility +=
          `<span>
        ${!(improvedata.commonData.includes('%')) ? ' (goal of less than ' + improvedata.commonGoals + ')' : ' (goal of more than ' + improvedata.commonGoals + ')'}
            </span>`
      };
      this.improveSummaryFacility += `</li>
        </ul>`;
    });
    this.improveSummaryFacility +=
      `<h3><b>Thrombolytic Decision to Administration (measure of speed of administration of thrombolytic by team after decision):</b></h3>`;
    this.improveTAMHATS.forEach((improvedata: any) => {

      this.improveSummaryFacility +=
        `<ul>
          <li class="mb-3"><span>${improvedata.QualityMetrics}</span> was at
          <b>${improvedata.commonData}</b>`;
      if (!(improvedata.commonData?.toString()).includes('%')) {
        this.improveSummaryFacility +=
          `<span> minutes</span>`
      };
      if (improvedata.commonGoals) {
        this.improveSummaryFacility +=
          `<span>
          ${!(improvedata.commonData.includes('%')) ? ' (goal of less than ' + improvedata.commonGoals + ')' : ' (goal of more than ' + improvedata.commonGoals + ')'}
          </span>`;
      }
      this.improveSummaryFacility += `</li>
        </ul>`
    });
    this.improveSummaryFacility += `</ul>`

    this.improveRapidiMO = this.improveRapidiMO + `

    <h2><b>RAPIDi Metric Outliers</b></h2>
    <!-- Activation -->
    <h3><b>Activation Time Interval</b></h3>
        <ul>
          <li class="mb-3">Activation Time Interval outliers beyond benchmark for EMS cases (goal of <b>0</b> minutes)
            was <b>${this.activationTimeListQualifyCountEMS}</b> out of <b>${this.activationTotalRecords}</b> cases
            (<b>Maximum</b>:${this.activationTriageTimeCasesMaximum}; <b>Mean</b>:${this.activationEMSTimeCasesMean};<b>Median</b>:${this.activationEMSTimeCasesMedian})
          </li>
          <li class="mb-3">Activation Time Interval outliers beyond benchmark for Triage cases (goal of <b>10</b> minutes)
            was <b>${this.activationTimeListQualifyCountTriage}</b> out of <b>${this.activationTgTotalRecords}</b> cases
            (<b>Maximum</b>:${this.activationTriageTimeCasesMaximum}; <b>Mean</b>:${this.activationTriageTimeCasesMean}; <b>Median</b>:${this.activationTriageTimeCasesMedian})
          </li>
          <li>From the EMS cases, ${this.WorkFlowTypePercentage}% were called at pre-arrival.</li>
        </ul>
        <!-- Assessment -->
        <h3><b>Assessment Time Interval</b></h3>
          <ul>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for EMS cases (goal of <b>12</b> minutes)
            was <b>${this.assessmentTimeListQualifyCountEMS}</b> out of <b>${this.assessmentTotalRecords}</b> cases
            (<b>Maximum</b>:${this.assessmentEMSTimeCasesMaximum}; <b>Mean</b>:${this.assessmentEMSTimeCasesMean}; <b>Median</b>:${this.assessmentEMSTimeCasesMedian})
          </li>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for Inpatient cases (goal of <b>12</b>
            minutes)
            was <b>${this.assessmentTimeListQualifyCountInpatient}</b> out of <b>${this.assessmentTotalInpatientRecords}</b> cases
            (<b>Maximum</b>: ${this.assessmentInpatientTimeCasesMaximum}; <b>Mean</b>: ${this.assessmentInpatientTimeCasesMean} ; <b>Median</b>:
            ${this.assessmentInpatientTimeCasesMedian})
          </li>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for Triage cases (goal of <b>12</b>
            minutes)
            was <b>${this.assessmentTimeListQualifyCountTriage}</b> out of <b>${this.assessmentTotalTriageRecords}</b> cases
            (<b>Maximum</b>: ${this.assessmentTriageTimeCasesMaximum}; <b>Mean</b>: ${this.assessmentTriageTimeCasesMean} ; <b>Median</b>:
            ${this.assessmentTriageTimeCasesMedian})
          </li>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for ED Onset cases (goal of <b>12</b>
            minutes)
            was <b>${this.assessmentTimeListQualifyCountEDOnset}</b> out of <b>${this.assessmentTotalEDOnsetRecords}</b> cases
            (<b>Maximum</b>: ${this.assessmentEDOnsetTimeCasesMaximum}; <b>Mean</b>: ${this.assessmentEDOnsetTimeCasesMean} ; <b>Median</b>:
            ${this.assessmentEDOnsetTimeCasesMedian})
          </li>
        </ul>
        <!-- Thrombolytic Decision -->
        <h3><b>Thrombolytic Decision Time Interval</b></h3>
        <ul>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for EMS cases (goal of <b>10</b> minutes)
            was <b>${this.thrombolyticDecisionTimeListQualifyCountEMS}</b> out of
            <b>${this.thrombolyticDecisionTotalRecords}</b> cases (<b>Maximum</b>:${this.thrombolyticDecisionEMSTimeCasesMaximum};
            <b>Mean</b>:${this.thrombolyticDecisionEMSTimeCasesMean}; <b>Median</b>:${this.thrombolyticDecisionEMSTimeCasesMedian})
          </li>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for Inpatient cases (goal of
            <b>10</b>
            minutes)
            was <b>${this.thrombolyticDecisionTimeListQualifyCountInpatient}</b> out of
            <b>${this.thrombolyticDecisionTotalInpatientRecords}</b> cases (<b>Maximum</b>: ${this.thrombolyticDecisionInpatientTimeCasesMaximum};
            <b>Mean</b>: ${this.thrombolyticDecisionInpatientTimeCasesMean} ; <b>Median</b>: ${this.thrombolyticDecisionInpatientTimeCasesMedian})
          </li>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for Triage cases (goal of
            <b>10</b>
            minutes)
            was <b>${this.thrombolyticDecisionTimeListQualifyCountTriage}</b> out of
            <b>${this.thrombolyticDecisionTotalTriageRecords}</b> cases (<b>Maximum</b>: ${this.thrombolyticDecisionTriageTimeCasesMaximum};
            <b>Mean</b>: ${this.thrombolyticDecisionTriageTimeCasesMean} ; <b>Median</b>: ${this.thrombolyticDecisionTriageTimeCasesMedian})
          </li>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for ED Onset cases (goal of
            <b>10</b>
            minutes)
            was <b>${this.thrombolyticDecisionTimeListQualifyCountEDOnset}</b> out of
            <b>${this.thrombolyticDecisionEDOnsetRecords}</b> cases (<b>Maximum</b>: ${this.thrombolyticDecisionEDOnsetTimeCasesMaximum};
            <b>Mean</b>: ${this.thrombolyticDecisionEDOnsetTimeCasesMean} ; <b>Median</b>: ${this.thrombolyticDecisionEDOnsetTimeCasesMedian})
          </li>
        </ul>  
        <!-- Thrombolytic Administration -->
        <h3><b>Thrombolytic Administration Time Interval</b></h3>
        <ul>
          <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for EMS cases (goal of <b>8</b>
            minutes) was <b>${this.thrombolyticAdministrationTimeListQualifyCountEMS}</b> out of
            <b>${this.thrombolyticAdministrationTotalRecords}</b> cases (<b>Maximum</b>:${this.thrombolyticAdministrationEMSTimeCasesMaximum}; <b>Mean</b>:${this.thrombolyticAdministrationEMSTimeCasesMean};
            <b>Median</b>:${this.thrombolyticAdministrationEMSCasesMedian})
          </li>
          <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for Inpatient cases
          (goal of <b>8</b>
          minutes) was <b>${this.thrombolyticAdministrationTimeListQualifyCountInpatient}</b> out of
          <b>${this.thrombolyticAdministrationTotalInpatientRecords}</b> cases (<b>Maximum</b>:
          ${this.thrombolyticAdministrationInpatientTimeCasesMaximum}; <b>Mean</b>: ${this.thrombolyticAdministrationInpatientTimeCasesMean} ;
          <b>Median</b>: ${this.thrombolyticAdministrationInpatientTimeCasesMedian})
        </li>
        <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for Triage cases
          (goal of <b>8</b>
          minutes) was <b>${this.thrombolyticAdministrationTimeListQualifyCountTriage}</b> out of
          <b>${this.thrombolyticAdministrationTotalTriageRecords}</b> cases (<b>Maximum</b>:
          ${this.thrombolyticAdministrationTriageTimeCasesMaximum}; <b>Mean</b>: ${this.thrombolyticAdministrationTriageTimeCasesMean} ;
          <b>Median</b>: ${this.thrombolyticAdministrationTriageTimeCasesMedian})
        </li>
        <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark ED Onset cases
          (goal of <b>8</b>
          minutes) was <b>${this.thrombolyticAdministrationTimeListQualifyCountEDOnset}</b> out of
          <b>${this.thrombolyticAdministrationTotalEDOnsetRecords}</b> cases (<b>Maximum</b>:
          ${this.thrombolyticAdministrationEDOnsetTimeCasesMaximum}; <b>Mean</b>: ${this.thrombolyticAdministrationEDOnsetTimeCasesMean} ;
          <b>Median</b>: ${this.thrombolyticAdministrationEDOnsetTimeCasesMedian})
        </li>
        </ul>
        
        <div class="content">`
    this.selectedOptionTextTemp = this.selectedOptionTextTemp.replace(/\s/g, '  ');
    this.selectedOptionTextTemp = this.selectedOptionTextTemp.replace(/[-]/g, ' -');

    this.improveFacilityTable += `
     
          
        </div>
<div style="display:block;">
        <table class="table table-responsive">
            <thead>
                <tr>`
    if (this.headerFacilityImprovefacilityList.length > 0) {
      this.headerFacilityImprovefacilityList.forEach((element: any, i: any) => {
        this.improveFacilityTable = this.improveFacilityTable + `
                      <th style="border-bottom:1px solid black;border-left:1px solid black;border-top:1px solid black;border-right:1px solid black;"">${element}</th>`
      });
    }

    this.improveFacilityTable = this.improveFacilityTable + `
                </tr>
            </thead>
            <tbody>`;

    this.bodyFacilityImprovefacilityList.forEach((element: any) => {
      this.improveFacilityTable = this.improveFacilityTable + ` 
      <tr>
          <td style="border-left:1px solid black;border-bottom:1px solid black;">${element[0].quality}</td>`
      if (element[0].data1 != null) {
        this.improveFacilityTable = this.improveFacilityTable + `
            <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${element[0].data1}</td>`
      }
      if (element[0].data2 != null) {
        this.improveFacilityTable = this.improveFacilityTable + `
            <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${element[0].data2}</td>`
      }
      if (element[0].data3 != null) {
        this.improveFacilityTable = this.improveFacilityTable + `
            <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${element[0].data3}</td>`
      }
      if (element[0].cumlative1 != null) {
        this.improveFacilityTable = this.improveFacilityTable + `
            <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${element[0].cumlative1}</td>`
      }
      if (element[0].cumlative2 != null) {
        this.improveFacilityTable = this.improveFacilityTable + `
            <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${element[0].cumlative2}</td>`
      }
      if (element[0].goals3 != null) {
        this.improveFacilityTable = this.improveFacilityTable + `
            <td style="border-left:1px solid black;border-bottom:1px solid black;border-right:1px solid black;"> ${element[0].goals3}</td>`
      } else {
        this.improveFacilityTable = this.improveFacilityTable + `
            <td style="border-left:1px solid black;border-bottom:1px solid black;border-right:1px solid black;"></td>`
      }

      this.improveFacilityTable = this.improveFacilityTable + `
        </tr>`
    })
    this.improveFacilityTable = this.improveFacilityTable + `
           </tbody>
        </table>
  </div>`

    if (this.qti_accomplishments_improvements != undefined) {
      this.improveFacilityTable = this.improveFacilityTable + `
    <div class="col-6">
    <label><b>Accomplishments/Improvements:<br></b> ${this.qti_accomplishments_improvements.replace(/</g, "&lt;").replaceAll('\n', '<br>')}</label>
  </div>`

    } else {
      this.improveFacilityTable = this.improveFacilityTable + `
    <div class="col-6">
    <b>Accomplishments/Improvements:</b> 0
  </div>`
    }
    if (this.qti_accomplishments_improvements != undefined) {
      this.improveFacilityTable = this.improveFacilityTable + `
    <div class="col-6">
    <label><b>Opportunities and PI Projects:<br></b> ${this.qti_opportunities_pi_projects.replace(/</g, "&lt;").replaceAll('\n', '<br>')}</label>
</div>`
    } else {
      this.improveFacilityTable = this.improveFacilityTable + `
    <div class="col-6">
  <b>Opportunities and PI Projects:</b> 0 
</div>`
    }
    this.improveFacilityTable = this.improveFacilityTable + `<div><h1 class="h-tag">GRAPHS</h1></div>`
    if (this.chartFoundBool) {
      this.improveFacilityTable = this.improveFacilityTable + `<div class="text-center w-full"><h4 class="h-tag"><b> No Data Available For Graphs </b></h1></div>`
      this. finalTemplateData = this.improveTemplate + this.improveSummaryFacility + this.improveRapidiMO + this.improveFacilityTable
    }
  }
  getAllPieChartsData() {
    let fromDateInitial: any;
    let toDateInitial: any;
    let YearQuarter: any;
    if (this.SelectedReportType == "monthly") {
      fromDateInitial = this.Month;
      toDateInitial = this.Month;
    }
    else if (this.SelectedReportType == "quarterly") {
      YearQuarter = this.datePipe.transform(this.YearQuarter, 'yyyy');
      if (this.selectedQuarter == 'quarter1') {
        fromDateInitial = `01/01/${YearQuarter}`;
        toDateInitial = `03/01/${YearQuarter}`;
      } else if (this.selectedQuarter == 'quarter2') {
        fromDateInitial = `04/01/${YearQuarter}`;
        toDateInitial = `06/01/${YearQuarter}`;
      } else if (this.selectedQuarter == 'quarter3') {
        fromDateInitial = `07/01/${YearQuarter}`;
        toDateInitial = `09/01/${YearQuarter}`;
      } else {
        fromDateInitial = `10/01/${YearQuarter}`;
        toDateInitial = `12/01/${YearQuarter}`;
      }
    }

    const frommonth = this.datePipe.transform(fromDateInitial, 'MM/dd/yyyy');
    const toMonth = this.datePipe.transform(toDateInitial, 'MM/dd/yyyy');

    this.improveFacilityData.data.fromMonth = frommonth;
    this.improveFacilityData.data.toMonth = toMonth;
    this.improveFacilityData.data.ReportType = 'monthly';
    this.subscription.push(
      this.improveService.GetPieChartData(this.RoleName, this.UId, this.improveFacilityData).subscribe({
        next: (res: any) => {
          if (res) {
            this.selectedDateVolumetric = [];
            this.firstMonthDateVolumetric = [];
            this.selectedDateStrokeAlert = [];
            this.selectedDateVolumetric = res.selectedDateVolumetric.data;
            this.firstMonthDateVolumetric = res.firstMonthDateVolumetric.data;
            this.selectedDateStrokeAlert = res.selectedDateStrokeAlert.data;
            if (this.selectedDateVolumetric != null &&
              this.firstMonthDateVolumetric != null &&
              this.selectedDateStrokeAlert != null) {
              this.getPiChart();
            }
          }
        },
        error: (err: any) => { },
      })
    );
  }
  getPiChart() {
    if (this.selectedDateVolumetric.length > 0) {
      let New = 0;
      let eeg = 0;
      let followup = 0
      let stat = 0;
      let strokealert = 0;
      let StrokeOnSameCart = 0;
      this.minDateSelectedVolumetric = '';
      this.maxDateSelectedVolumetric = '';
      this.minDateSelectedVolumetric = this.selectedDateVolumetric[0].date;
      this.maxDateSelectedVolumetric = this.selectedDateVolumetric[this.selectedDateVolumetric.length - 1].date;
      this.selectedDateVolumetric.forEach((element: any) => {
        New += element.New;
        eeg += element.eeg;
        followup += element.followup;
        stat += element.stat;
        strokealert += element.strokealert;
        StrokeOnSameCart += element.StrokeOnSameCart;
      });
      this.TotaAllCasesSelectedVolimatric = New + eeg + followup + stat + strokealert + StrokeOnSameCart;
      this.pieDataSelectedVolimatric = [
        { category: 'StrokeAlert', value: strokealert, colorField: "#ed1878" },
        { category: 'STAT', value: stat, colorField: "#00164c" },
        { category: 'New', value: New, colorField: "#9f1f60" },
        { category: 'FollowUp', value: followup, colorField: "#653193" },
        { category: 'EEG', value: eeg, colorField: "#00aeef" },
        { category: 'Stroke on Same Cart', value: StrokeOnSameCart, colorField:"#808080" },
      ];
      let val: any;
      val = this.selectedDateVolumetric.every((val: any) => {
        return val.New === 0 && val.eeg === 0 && val.followup === 0 && val.stat === 0 && val.strokealert === 0 && val.StrokeOnSameCart === 0
      });
      if (val) {
        this.selectedDateVolumetricBool = true;
      } else {
        this.selectedDateVolumetricBool = false;
      }
    }
    if (this.firstMonthDateVolumetric.length > 0) {
      let New = 0;
      let eeg = 0;
      let followup = 0
      let stat = 0;
      let strokealert = 0;
      let StrokeOnSameCart = 0;
      this.minDateFirstMonthVolumetric = '';
      this.maxDateFirstMonthVolumetric = '';
      this.minDateFirstMonthVolumetric = this.firstMonthDateVolumetric[0].date;
      this.maxDateFirstMonthVolumetric = this.firstMonthDateVolumetric[this.firstMonthDateVolumetric.length - 1].date;
      this.firstMonthDateVolumetric.forEach((element: any) => {
        New += element.New;
        eeg += element.eeg;
        followup += element.followup;
        stat += element.stat;
        strokealert += element.strokealert;
        StrokeOnSameCart += element.StrokeOnSameCart;
      });
      this.TotaAllFirstMonthDateVolumetric = New + eeg + followup + stat + strokealert + StrokeOnSameCart;
      this.firstMonthDateVolumetric = [
        { category: 'StrokeAlert', value: strokealert, colorField: "#ed1878" },
        { category: 'STAT', value: stat, colorField: "#00164c" },
        { category: 'New', value: New, colorField: "#9f1f60" },
        { category: 'FollowUp', value: followup, colorField: "#653193" },
        { category: 'EEG', value: eeg, colorField: "#00aeef" },
        { category: 'Stroke on Same Cart', value: StrokeOnSameCart, colorField:"#808080" },
      ];
      let val: any;
      val = this.firstMonthDateVolumetric.every((val: any) => {
        return val.value === 0
      });
      if (val) {
        this.firstMonthDateVolumetricBool = true;
      } else {
        this.firstMonthDateVolumetricBool = false;
      }
    }
    if (this.selectedDateStrokeAlert.length > 0) {
      let EMS = 0;
      let Triage = 0;
      let Inpatient = 0
      let EdOnset = 0;
      let AudioConsult = 0;
      let SameCart = 0;
      this.minDateSelectedStrokeAlert = '';
      this.maxDateSelectedStrokeAlert = '';
      this.minDateSelectedStrokeAlert = this.selectedDateStrokeAlert[0].date;
      this.maxDateSelectedStrokeAlert = this.selectedDateStrokeAlert[this.selectedDateStrokeAlert.length - 1].date;
      this.selectedDateStrokeAlert.forEach((element: any) => {
        EMS += element.EMS;
        Triage += element.Triage;
        Inpatient += element.Inpatient;
        EdOnset += element.EDOnset;
        AudioConsult += element.AudioConsult;
        SameCart += element.SameCart;
      });
      this.TotaAllSelectedDateStrokeAlert = EMS + Triage + Inpatient + EdOnset + AudioConsult + SameCart;
      this.pieDataSelectedDateStrokeAlert = [
        { category: 'EMS', value: EMS, colorField: "#ed1878" },
        { category: 'Triage', value: Triage, colorField: "#00164c" },
        { category: 'Inpatient', value: Inpatient, colorField: "#9f1f60" },
        { category: 'ED Onset', value: EdOnset, colorField: "#653193" },
        { category: 'Audio Consult', value: AudioConsult, colorField: "#00aeef" },
        { category: 'Stroke on Same Cart', value: SameCart, colorField:"#808080" },
      ];
      let val: any;
      val = this.selectedDateStrokeAlert.every((val: any) => {
        return val.EMS === 0 && val.Triage === 0 && val.Inpatient === 0 && val.EDOnset === 0 && val.AudioConsult === 0 && val.SameCart === 0
      });
      if (val) {
        this.selectedDateStrokeAlertBool = true;
      } else {
        this.selectedDateStrokeAlertBool = false;
      }
    }
    
    this.improveSearchLoader = false;
    this.showProgressSpinner = false;
  }
  public labelContent(args: LegendLabelsContentArgs): string {
    const result = args.dataItem.category + ": \n" + args.dataItem.value;
    return result;
  }
  visualContent = (e: SeriesLabelsVisualArgs) => {
    try {
      const defaultLabel: any = e.createVisual();
      const value = parseFloat(e.text);
      defaultLabel.children
      const font = defaultLabel.children[2].chartElement.options.font;
      defaultLabel.children[2].chartElement.options.font = `bold 18px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;
      defaultLabel.children[2].chartElement.options.color = "#653193";
      return defaultLabel;
    } catch (error) {
      throw error;
    }
  }
  getFacilityDashboardAllCharts() {
    let monthQuarterDate: any;
    let YearQuarter: any;
    let dateString: any;
    this.chartFoundBool = false;
    if (this.SelectedReportType == "monthly") {
      monthQuarterDate = this.Month;
    }
    else if (this.SelectedReportType == "quarterly") {
      YearQuarter = this.datePipe.transform(this.YearQuarter, 'yyyy');
      if (this.selectedQuarter == 'quarter1') {
        dateString = `01/03/${YearQuarter}`;
      } else if (this.selectedQuarter == 'quarter2') {
        dateString = `01/06/${YearQuarter}`;
      } else if (this.selectedQuarter == 'quarter3') {
        dateString = `01/09/${YearQuarter}`;
      } else {
        dateString = `01/12/${YearQuarter}`;
      }
      const dateParts = dateString.split('/');
      monthQuarterDate = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
    }
    const previous11Months = Array.from({ length: 11 }, (_, i) => {
      const date = new Date(monthQuarterDate.getFullYear(), monthQuarterDate.getMonth() - i - 1, 1);
      return date;
    });

    const lastDate = previous11Months.pop();
    const frommonth = this.datePipe.transform(lastDate, 'MM/dd/yyyy');
    const toMonth = this.datePipe.transform(monthQuarterDate, 'MM/dd/yyyy');

    this.improveFacilityData.data.fromMonth = frommonth;
    this.improveFacilityData.data.toMonth = toMonth;
    this.improveFacilityData.data.ReportType = "monthly";
    this.subscription.push(
      this.analyzeService.GetFacilityDashboardAllChartValues(this.RoleName, this.UId, this.improveFacilityData)
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.allChartsData = res.data;
              this.emptyArrays();
              this.doortostartMinDate = 0;
              this.ActivationtoAssessmentMinDate = 0;
              this.starttoresponseMinDate = 0;
              this.doortoneedleMinDate = 0;
              this.activitationtoneedleMinDate = 0;
              this.AssessmenttoThrombolyticMinDate = 0;
              this.ThrombolytictoThrombolyticMinDate = 0;

              if (res.data == null || res.data[0].Title == null) {
                this.chartFoundBool = true;
              }

              this.allChartsData?.forEach((item: any) => {

                if (item.Title == 'Door to TS Notification Ave. & Median Minutes') {
                  this.flag = 0;
                  this.doortostarttitle = item.Title;
                  const ceckNullValuesMean = item.MeanCalculation.filter((i: any) => i != null);
                  const ceckNullValuesMedian = item.MedianCalculation.filter((i: any) => i != null);
                  if (ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0) {
                    this.doortostartMinDate = new Date(item.MinDate).getTime();
                  }
                  this.doortostartmean = item.Mean;
                  this.doortostartmedian = item.Median;
                  this.doortostartcatgory = item.Category;

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.doortostartmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.doortostartmeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.doortostartmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.doortostartmediancal.push(value)
                    }
                  });

                  let mergeddoortostartArray = [...this.doortostartmeancal, ...this.doortostartmediancal];
                  this.doortostartMaxDate = Math.max(...mergeddoortostartArray);
                }
                else if (item.Title == "% 10 Min or Less Activation (EMS)") {
                  let transformedData = [];
                  let transformedDataInitial: any;
                  transformedDataInitial = item.Category;
                  if (transformedDataInitial) {
                    transformedData = transformedDataInitial.map((element: any) => {
                      const index = element.indexOf("N=");
                      return index !== -1 ? element.substring(0, index) : element;
                    });
                  }
                  this.activationemscatgory = transformedData;
                  this.activationemsmeancal = item.MeanCalculation;
                }
                else if (item.Title == "% 10 Min or Less Activation (PV)") {
                  this.activationPvCatgory = item.Category;
                  this.activationpvmeancal = item.MeanCalculation;
                }
                else if (item.Title == "Activation to Assessment Median Mins") {
                  this.flag = 0;
                  this.ActivationtoAssessmenttitle = item.Title;
                  this.ActivationtoAssessmentmean = item.Mean;
                  this.ActivationtoAssessmentmedian = item.Median;
                  this.ActivationtoAssessmentcatgory = item.Category;
                  const ceckNullValuesMean = item.MeanCalculation.filter((i: any) => i != null);
                  const ceckNullValuesMedian = item.MedianCalculation.filter((i: any) => i != null);
                  if (ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0) {
                    this.ActivationtoAssessmentMinDate = new Date(item.MinDate).getTime();
                  }

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.ActivationtoAssessmentmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.ActivationtoAssessmentmeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.ActivationtoAssessmentmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.ActivationtoAssessmentmediancal.push(value);
                    }
                  });

                  let mergedActivationtoAssessmentArray = [...this.ActivationtoAssessmentmeancal, ...this.ActivationtoAssessmentmediancal];
                  this.ActivationtoAssessmentMaxDate = Math.max(...mergedActivationtoAssessmentArray);
                }
                else if (item.Title == "TS Notification to Initial Response Average & Median Minute") {
                  this.flag = 0;
                  this.starttoresponsetitle = item.Title;
                  this.starttoresponsemean = item.Mean;
                  this.starttoresponsemedian = item.Median;
                  this.starttoresponsecatgory = item.Category;
                  const ceckNullValuesMean = item.MeanCalculation.filter((i: any) => i != null);
                  const ceckNullValuesMedian = item.MedianCalculation.filter((i: any) => i != null);
                  if (ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0) {
                    this.starttoresponseMinDate = new Date(item.MinDate).getTime();
                  }

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.starttoresponsemeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.starttoresponsemeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.starttoresponsemediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.starttoresponsemediancal.push(value);
                    }
                  });

                  let mergedstarttoresponseArray = [...this.starttoresponsemeancal, ...this.starttoresponsemediancal];
                  this.starttoresponseMaxDate = Math.max(...mergedstarttoresponseArray);
                }
                else if (item.Title == "THROMBOLYTIC ADMINISTERED #") {
                  this.alteplaseadmintitle = item.Title;
                  this.alteplaseadminmean = item.Mean;
                  this.alteplaseadmincatgory = item.Category;
                  this.alteplaseadminmeancal = item.MeanCalculation;
                }
                else if (item.Title == "Door to Needle Average & Median (min:sec)") {
                  this.flag = 0;
                  this.doortoneedletitle = item.Title;
                  this.doortoneedlemean = item.Mean;
                  this.doortoneedlemedian = item.Median;
                  this.doortoneedlecatgory = item.Category;
                  const ceckNullValuesMean = item.MeanCalculation.filter((i: any) => i != null);
                  const ceckNullValuesMedian = item.MedianCalculation.filter((i: any) => i != null);
                  if (ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0) {
                    this.doortoneedleMinDate = new Date(item.MinDate).getTime();
                  }

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.doortoneedlemeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.doortoneedlemeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.doortoneedlemediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.doortoneedlemediancal.push(value);
                    }
                  });

                  let mergeddoortoneedleArray = [...this.doortoneedlemeancal, ...this.doortoneedlemediancal];
                  this.doortoneedleMaxDate = Math.max(...mergeddoortoneedleArray);
                }
                else if (item.Title == "Activation to Needle Average & Median") {
                  this.flag = 0;
                  this.activitationtoneedletitle = item.Title;
                  this.activitationtoneedlemean = item.Mean;
                  this.activitationtoneedlemedian = item.Median;
                  this.activitationtoneedlecatgory = item.Category;
                  const ceckNullValuesMean = item.MeanCalculation.filter((i: any) => i != null);
                  const ceckNullValuesMedian = item.MedianCalculation.filter((i: any) => i != null);
                  if (ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0) {
                    this.activitationtoneedleMinDate = new Date(item.MinDate).getTime();
                  }

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.activitationtoneedlemeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.activitationtoneedlemeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.activitationtoneedlemediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.activitationtoneedlemediancal.push(value);
                    }
                  });

                  let mergedactivitationtoneedleArray = [...this.activitationtoneedlemeancal, ...this.activitationtoneedlemediancal];
                  this.activitationtoneedleMaxDate = Math.max(...mergedactivitationtoneedleArray);
                }
                else if (item.Title == "Assessment to Thrombolytic Decision-making Median Mins") {
                  this.flag = 0;
                  this.AssessmenttoThrombolytictitle = item.Title;
                  this.AssessmenttoThrombolyticmean = item.Mean;
                  this.AssessmenttoThrombolyticmedian = item.Median;
                  this.AssessmenttoThrombolyticcatgory = item.Category;
                  const ceckNullValuesMean = item.MeanCalculation.filter((i: any) => i != null);
                  const ceckNullValuesMedian = item.MedianCalculation.filter((i: any) => i != null);
                  if (ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0) {
                    this.AssessmenttoThrombolyticMinDate = new Date(item.MinDate).getTime();
                  }

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.AssessmenttoThrombolyticmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.AssessmenttoThrombolyticmeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.AssessmenttoThrombolyticmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.AssessmenttoThrombolyticmediancal.push(value);
                    }
                  });

                  let mergedAssessmenttoThrombolyticArray = [...this.AssessmenttoThrombolyticmeancal, ...this.AssessmenttoThrombolyticmediancal];
                  this.AssessmenttoThrombolyticMaxDate = Math.max(...mergedAssessmenttoThrombolyticArray);
                }
                else if (item.Title == "Thrombolytic Decision Making to Admin Median Mins") {
                  this.flag = 0;

                  this.ThrombolytictoThrombolyticadministrationavg = item.Mean;
                  this.ThrombolytictoThrombolyticadministrationmedian = item.Median;
                  this.ThrombolytictoThrombolyticadministrationcatgory = item.Category;
                  const ceckNullValuesMean = item.MeanCalculation.filter((i: any) => i != null);
                  const ceckNullValuesMedian = item.MedianCalculation.filter((i: any) => i != null);
                  if (ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0) {
                    this.ThrombolytictoThrombolyticMinDate = new Date(item.MinDate).getTime();
                  }

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.ThrombolytictoThrombolyticadministrationmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.ThrombolytictoThrombolyticadministrationmeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.ThrombolytictoThrombolyticadministrationmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.ThrombolytictoThrombolyticadministrationmediancal.push(value);
                    }
                  });

                  let mergedThrombolytictoThrombolyticadministrationArray = [...this.ThrombolytictoThrombolyticadministrationmeancal, ...this.ThrombolytictoThrombolyticadministrationmediancal];
                  this.ThrombolytictoThrombolyticMaxDate = Math.max(...mergedThrombolytictoThrombolyticadministrationArray);
                }
                else if (item.Title == "DTN Less or Equal 30 Minutes %") {
                  this.DTN30percentmean = item.Mean;
                  this.DTN30percentcatgory = item.Category;
                  this.DTN30percentmeancal = item.MeanCalculation;
                }
                else if (item.Title == "DTN Less or Equal 45 Minutes %") {
                  this.DTN45percentcatgory = item.Category;
                  this.DTN45percentmeancal = item.MeanCalculation;
                }
                else if (item.Title == "DTN Less or Equal 60 Minutes %") {
                  this.DTN60percentcatgory = item.Category;
                  this.DTN60percentmeancal = item.MeanCalculation;
                }
                else if (item.Title == "Door to NIR Callback Ave. & Median Minutes") {
                  this.flag = 0;
                  this.doortonircallbacktitle = item.Title;

                  this.doortonircallbackmean = item.Mean;
                  this.doortonircallbackmedian = item.Median;
                  this.doortonircallbackcatgory = item.Category;

                  this.doortonircallbackmeancal = [];
                  this.doortonircallbackmediancal = [];

                  item.MeanCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.doortonircallbackmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.doortonircallbackmeancal.push(value);
                    }
                  });
                  item.MedianCalculation.forEach((value: any) => {
                    if (value != null) {
                      this.doortonircallbackmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                    } else {
                      this.doortonircallbackmediancal.push(value);
                    }
                  });
                }
              });


              this.Door_to_TS_Notification_Ave_Median_Minutes_Chart(this.doortostarttitle, this.doortostartmean, this.doortostartmedian, this.doortostartmeancal, this.doortostartmediancal, this.doortostartcatgory, this.flag);
              this.Ten_Min_or_Less_Activation_EMS_PV_Chart(this.activationemsmeancal, this.activationpvmeancal, this.activationemscatgory);
              this.Activation_to_Assessment_Median_Mins_Chart(this.ActivationtoAssessmenttitle, this.ActivationtoAssessmentmean, this.ActivationtoAssessmentmedian, this.ActivationtoAssessmentmeancal, this.ActivationtoAssessmentmediancal, this.ActivationtoAssessmentcatgory, this.flag);
              this.TS_Notification_to_Initial_Response_Average_Median_Minute_Chart(this.starttoresponsetitle, this.starttoresponsemean, this.starttoresponsemedian, this.starttoresponsemeancal, this.starttoresponsemediancal, this.starttoresponsecatgory, this.flag);
              this.THROMBOLYTIC_ADMINISTERED_Chart(this.alteplaseadmintitle, this.alteplaseadminmean, this.alteplaseadminmeancal, this.alteplaseadmincatgory);
              this.Door_to_Needle_Average_Median_min_sec_Chart(this.doortoneedletitle, this.doortoneedlemean, this.doortoneedlemedian, this.doortoneedlemeancal, this.doortoneedlemediancal, this.doortoneedlecatgory, this.flag);
              this.Activation_to_Needle_Average_Median_Chart(this.activitationtoneedletitle, this.activitationtoneedlemean, this.activitationtoneedlemedian, this.activitationtoneedlemeancal, this.activitationtoneedlemediancal, this.activitationtoneedlecatgory, this.flag);
              this.Assessment_to_Thrombolytic_Decision_making_Median_Mins_Chart(this.AssessmenttoThrombolytictitle, this.AssessmenttoThrombolyticmean, this.AssessmenttoThrombolyticmedian, this.AssessmenttoThrombolyticmeancal, this.AssessmenttoThrombolyticmediancal, this.AssessmenttoThrombolyticcatgory, this.flag);
              this.Thrombolytic_Decision_Making_to_Admin_Median_Mins_Chart(this.ThrombolytictoThrombolyticadministrationavg, this.ThrombolytictoThrombolyticadministrationmedian, this.ThrombolytictoThrombolyticadministrationmeancal, this.ThrombolytictoThrombolyticadministrationmediancal, this.ThrombolytictoThrombolyticadministrationcatgory, this.flag);
              this.DTN_30_45_60_Chart(this.DTN30percentmeancal, this.DTN45percentmeancal, this.DTN60percentmeancal, this.DTN30percentcatgory);
              // this.Door_to_NIR_Call_back_Ave_Median_Minutes_Chart(this.doortonircallbacktitle, this.doortonircallbackmean, this.doortonircallbackmedian, this.doortonircallbackmeancal, this.doortonircallbackmediancal, this.doortonircallbackcatgory, this.flag);


            }
          }
        })
    );
  }
  emptyArrays() {
    this.doortostartmeancal = [];
    this.doortostartmediancal = [];
    this.doortostartcatgory = [];
    this.activationemsmeancal = [];
    this.activationemscatgory = [];
    this.activationpvmeancal = [];
    this.ActivationtoAssessmentcatgory = [];
    this.ActivationtoAssessmentmediancal = [];
    this.ActivationtoAssessmentmeancal = [];
    this.starttoresponsecatgory = [];
    this.starttoresponsemeancal = [];
    this.starttoresponsemediancal = [];
    this.alteplaseadmincatgory = [];
    this.alteplaseadminmeancal = [];
    this.doortoneedlecatgory = [];
    this.doortoneedlemeancal = [];
    this.doortoneedlemediancal = [];
    this.activitationtoneedlecatgory = []
    this.activitationtoneedlemeancal = [];
    this.activitationtoneedlemediancal = [];
    this.AssessmenttoThrombolyticcatgory = [];
    this.AssessmenttoThrombolyticmeancal = [];
    this.AssessmenttoThrombolyticmediancal = [];
    this.ThrombolytictoThrombolyticadministrationcatgory = [];
    this.ThrombolytictoThrombolyticadministrationmeancal = [];
    this.ThrombolytictoThrombolyticadministrationmediancal = [];
    this.DTN30percentcatgory = [];
    this.DTN30percentmeancal = [];
    this.DTN45percentmeancal = [];
    this.DTN60percentmeancal = [];
  };

  public seriesColors: any = ['#ed2078', '#36286b', '#3B82F6'];
  doortostartMeanChart: any = [];
  doortostartMedianChart: any = [];
  doortostartMeanChartContent: any;
  doortostartMedianChartContent: any;
  Door_to_TS_Notification_Ave_Median_Minutes_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    let doortostartMeanChartDate: any = []
    let doortostartMedianChartDate: any = []
    let doortostartMeanChartDateTemp: any = [];
    let doortostartMedianChartDateTemp: any = [];



    this.doortostartmeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        doortostartMeanChartDate.push(calculatedDate);
        doortostartMeanChartDateTemp.push(calculatedDate);
      } else {
        doortostartMeanChartDate.push(value);
      }
    });

    this.doortostartMeanChart = doortostartMeanChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let dttsnmn = -1;
    this.doortostartMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if (dttsnmn == doortostartMeanChartDateTemp.length - 1) {
        dttsnmn = -1;
      }
      dttsnmn++
      return doortostartMeanChartDateTemp[dttsnmn];
    };



    this.doortostartmediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        doortostartMedianChartDate.push(calculatedDate);
        doortostartMedianChartDateTemp.push(calculatedDate);

      } else {
        doortostartMedianChartDate.push(value);
      }
    });
    this.doortostartMedianChart = doortostartMedianChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let dttsnnmd = -1;
    this.doortostartMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if (dttsnnmd == doortostartMedianChartDateTemp.length - 1) {
        dttsnnmd = -1;
      }
      dttsnnmd++
      return doortostartMedianChartDateTemp[dttsnnmd];
    };

  }

  Ten_Min_or_Less_Activation_EMS_PV_Chart(EMSMeanCalculations: any, PVMeanCalculations: any, Category: any) {
    this.Ten_Min_or_Less_Activation_EMS_PV_Chart_Data = [];

  }

  ActivationtoAssessmentMeanChart: any = [];
  ActivationtoAssessmentMedianChart: any = [];
  ActivationtoAssessmentMeanChartContent: any;
  ActivationtoAssessmentMedianChartContent: any;

  Activation_to_Assessment_Median_Mins_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    let acivationToAssessmentMeanChartDate: any = [];
    let acivationToAssessmentMeanChartDateTemp: any = [];
    let acivationToAssessmentMedianChartDate: any = []
    let acivationToAssessmentMedianChartDateTemp: any = []


    this.ActivationtoAssessmentmeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        acivationToAssessmentMeanChartDate.push(calculatedDate);
        acivationToAssessmentMeanChartDateTemp.push(calculatedDate);
      } else {
        acivationToAssessmentMeanChartDate.push(value);
      }
    });
    this.ActivationtoAssessmentMeanChart = acivationToAssessmentMeanChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let atatmn = -1
    this.ActivationtoAssessmentMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if (atatmn == acivationToAssessmentMeanChartDateTemp.length - 1) {
        atatmn = -1;
      }
      atatmn++
      return acivationToAssessmentMeanChartDateTemp[atatmn];
    };



    this.ActivationtoAssessmentmediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        acivationToAssessmentMedianChartDate.push(calculatedDate);
        acivationToAssessmentMedianChartDateTemp.push(calculatedDate);
      } else {
        acivationToAssessmentMedianChartDate.push(value);
      }
    });
    this.ActivationtoAssessmentMedianChart = acivationToAssessmentMedianChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let atatmd = -1
    this.ActivationtoAssessmentMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if (atatmd == acivationToAssessmentMedianChartDateTemp.length - 1) {
        atatmd = -1;
      }
      atatmd++
      return acivationToAssessmentMedianChartDateTemp[atatmd];
    };

  }

  TS_Notification_to_Initial_ResponseMeanChart: any = [];
  TS_Notification_to_Initial_ResponseMedianChart: any = [];
  TS_Notification_to_Initial_ResponseMeanChartContent: any;
  TS_Notification_to_Initial_ResponseMedianChartContent: any;

  TS_Notification_to_Initial_Response_Average_Median_Minute_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {

    let TS_Notification_to_Initial_ResponseMeanChartDate: any = [];
    let TS_Notification_to_Initial_ResponseMeanChartDateTemp: any = [];
    let TS_Notification_to_Initial_ResponseMedianChartDate: any = []
    let TS_Notification_to_Initial_ResponseMedianChartDateTemp: any = []


    this.starttoresponsemeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        TS_Notification_to_Initial_ResponseMeanChartDate.push(calculatedDate)
        TS_Notification_to_Initial_ResponseMeanChartDateTemp.push(calculatedDate)
      } else {
        TS_Notification_to_Initial_ResponseMeanChartDate.push(value)
      }
    });
    this.TS_Notification_to_Initial_ResponseMeanChart = TS_Notification_to_Initial_ResponseMeanChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let tsntirmn = -1
    this.TS_Notification_to_Initial_ResponseMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if (tsntirmn == TS_Notification_to_Initial_ResponseMeanChartDateTemp.length - 1) {
        tsntirmn = -1
      }
      tsntirmn++
      return TS_Notification_to_Initial_ResponseMeanChartDateTemp[tsntirmn];
    };



    this.starttoresponsemediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        TS_Notification_to_Initial_ResponseMedianChartDate.push(calculatedDate)
        TS_Notification_to_Initial_ResponseMedianChartDateTemp.push(calculatedDate)
      } else {
        TS_Notification_to_Initial_ResponseMedianChartDate.push(value)
      }
    });
    this.TS_Notification_to_Initial_ResponseMedianChart = TS_Notification_to_Initial_ResponseMedianChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let tsntirmd = -1
    this.TS_Notification_to_Initial_ResponseMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if (tsntirmd == TS_Notification_to_Initial_ResponseMedianChartDateTemp.length - 1) {
        tsntirmd = -1;
      }
      tsntirmd++
      return TS_Notification_to_Initial_ResponseMedianChartDateTemp[tsntirmd];
    };

  }

  THROMBOLYTIC_ADMINISTERED_Chart(Title: any, Mean: any, MeanCalculations: any, Category: any) {

  }

  Door_to_NeedleMeanChart: any = [];
  Door_to_NeedleMedianChart: any = [];
  Door_to_NeedleMeanChartContent: any;
  Door_to_NeedleMedianChartContent: any;

  Door_to_Needle_Average_Median_min_sec_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {

    let Door_to_NeedleMeanChartDate: any = []
    let Door_to_NeedleMeanChartDateTemp: any = []
    let Door_to_NeedleMedianChartDate: any = []
    let Door_to_NeedleMedianChartDateTemp: any = []


    this.doortoneedlemeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Door_to_NeedleMeanChartDate.push(calculatedDate)
        Door_to_NeedleMeanChartDateTemp.push(calculatedDate)
      } else {
        Door_to_NeedleMeanChartDate.push(value)
      }
    });
    this.Door_to_NeedleMeanChart = Door_to_NeedleMeanChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let dtnmn = -1
    this.Door_to_NeedleMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if (dtnmn == Door_to_NeedleMeanChartDateTemp.length - 1) {
        dtnmn = -1;
      }
      dtnmn++
      return Door_to_NeedleMeanChartDateTemp[dtnmn];
    };


    this.doortoneedlemediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Door_to_NeedleMedianChartDate.push(calculatedDate)
        Door_to_NeedleMedianChartDateTemp.push(calculatedDate)
      } else {
        Door_to_NeedleMedianChartDate.push(value)
      }
    });
    this.Door_to_NeedleMedianChart = Door_to_NeedleMedianChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let dtnmd = -1
    this.Door_to_NeedleMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if (dtnmd == Door_to_NeedleMedianChartDateTemp.length - 1) {
        dtnmd = -1;
      }
      dtnmd++
      return Door_to_NeedleMedianChartDateTemp[dtnmd];
    };

  }

  Activation_to_NeedleMeanChart: any = [];
  Activation_to_NeedleMedianChart: any = [];
  Activation_to_NeedleMeanChartContent: any;
  Activation_to_NeedleMedianChartContent: any;

  Activation_to_Needle_Average_Median_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {

    let Activation_to_NeedleMeanChartDate: any = []
    let Activation_to_NeedleMeanChartDateTemp: any = []
    let Activation_to_NeedleMedianChartDate: any = []
    let Activation_to_NeedleMedianChartDateTemp: any = []



    this.activitationtoneedlemeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Activation_to_NeedleMeanChartDate.push(calculatedDate)
        Activation_to_NeedleMeanChartDateTemp.push(calculatedDate)
      } else {
        Activation_to_NeedleMeanChartDate.push(value)
      }
    });
    this.Activation_to_NeedleMeanChart = Activation_to_NeedleMeanChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let atnmn = -1
    this.Activation_to_NeedleMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if (atnmn == Activation_to_NeedleMeanChartDateTemp.length - 1) {
        atnmn = -1
      }
      atnmn++
      return Activation_to_NeedleMeanChartDateTemp[atnmn];
    };


    this.activitationtoneedlemediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Activation_to_NeedleMedianChartDate.push(calculatedDate)
        Activation_to_NeedleMedianChartDateTemp.push(calculatedDate)
      } else {
        Activation_to_NeedleMedianChartDate.push(value)

      }
    });
    this.Activation_to_NeedleMedianChart = Activation_to_NeedleMedianChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let dtsmn = -1
    this.Activation_to_NeedleMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if (dtsmn == Activation_to_NeedleMedianChartDateTemp.length - 1) {
        dtsmn = -1
      }
      dtsmn++
      return Activation_to_NeedleMedianChartDateTemp[dtsmn];
    };

  }

  Assessment_to_Thrombolytic_DecisionMeanChart: any = [];
  Assessment_to_Thrombolytic_DecisionMedianChart: any = [];
  Assessment_to_Thrombolytic_DecisionMeanChartContent: any;
  Assessment_to_Thrombolytic_DecisionMedianChartContent: any;

  Assessment_to_Thrombolytic_Decision_making_Median_Mins_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {

    let Assessment_to_Thrombolytic_DecisionMeanChartDate: any = []
    let Assessment_to_Thrombolytic_DecisionMeanChartDateTemp: any = []
    let Assessment_to_Thrombolytic_DecisionMedianChartDate: any = []
    let Assessment_to_Thrombolytic_DecisionMedianChartDateTemp: any = []



    this.AssessmenttoThrombolyticmeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Assessment_to_Thrombolytic_DecisionMeanChartDate.push(calculatedDate)
        Assessment_to_Thrombolytic_DecisionMeanChartDateTemp.push(calculatedDate)
      } else {
        Assessment_to_Thrombolytic_DecisionMeanChartDate.push(value)
      }
    });
    this.Assessment_to_Thrombolytic_DecisionMeanChart = Assessment_to_Thrombolytic_DecisionMeanChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let attdmmn = -1
    this.Assessment_to_Thrombolytic_DecisionMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if (attdmmn == Assessment_to_Thrombolytic_DecisionMeanChartDateTemp.length - 1) {
        attdmmn = -1;
      }
      attdmmn++
      return Assessment_to_Thrombolytic_DecisionMeanChartDateTemp[attdmmn];
    };


    this.AssessmenttoThrombolyticmediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Assessment_to_Thrombolytic_DecisionMedianChartDate.push(calculatedDate)
        Assessment_to_Thrombolytic_DecisionMedianChartDateTemp.push(calculatedDate)
      } else {
        Assessment_to_Thrombolytic_DecisionMedianChartDate.push(value);
      }
    });
    this.Assessment_to_Thrombolytic_DecisionMedianChart = Assessment_to_Thrombolytic_DecisionMedianChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let attdmmd = -1
    this.Assessment_to_Thrombolytic_DecisionMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if (attdmmd == Assessment_to_Thrombolytic_DecisionMedianChartDateTemp.length - 1) {
        attdmmd = -1
      }
      attdmmd++
      return Assessment_to_Thrombolytic_DecisionMedianChartDateTemp[attdmmd];
    };
  }

  Thrombolytic_Decision_Making_to_AdminMeanChart: any = [];
  Thrombolytic_Decision_Making_to_AdminMedianChart: any = [];
  Thrombolytic_Decision_Making_to_AdminMeanChartContent: any;
  Thrombolytic_Decision_Making_to_AdminMedianChartContent: any;

  Thrombolytic_Decision_Making_to_Admin_Median_Mins_Chart(Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {

    let Thrombolytic_Decision_Making_to_AdminMeanChartDate: any = []
    let Thrombolytic_Decision_Making_to_AdminMeanChartDateTemp: any = []
    let Thrombolytic_Decision_Making_to_AdminMedianChartDate: any = []
    let Thrombolytic_Decision_Making_to_AdminMedianChartDateTemp: any = []



    this.ThrombolytictoThrombolyticadministrationmeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Thrombolytic_Decision_Making_to_AdminMeanChartDate.push(calculatedDate)
        Thrombolytic_Decision_Making_to_AdminMeanChartDateTemp.push(calculatedDate)
      } else {
        Thrombolytic_Decision_Making_to_AdminMeanChartDate.push(value)
      }
    });
    this.Thrombolytic_Decision_Making_to_AdminMeanChart = Thrombolytic_Decision_Making_to_AdminMeanChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let tdmtamn = -1
    this.Thrombolytic_Decision_Making_to_AdminMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if (tdmtamn == Thrombolytic_Decision_Making_to_AdminMeanChartDateTemp.length - 1) {
        tdmtamn = -1
      }
      tdmtamn++
      return Thrombolytic_Decision_Making_to_AdminMeanChartDateTemp[tdmtamn];
    };


    this.ThrombolytictoThrombolyticadministrationmediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        Thrombolytic_Decision_Making_to_AdminMedianChartDate.push(calculatedDate)
        Thrombolytic_Decision_Making_to_AdminMedianChartDateTemp.push(calculatedDate)
      } else {
        Thrombolytic_Decision_Making_to_AdminMedianChartDate.push(value)
      }
    });
    this.Thrombolytic_Decision_Making_to_AdminMedianChart = Thrombolytic_Decision_Making_to_AdminMedianChartDate.map((str: any) => str == null ? null : parseInt(str, 10));
    let tdmtamd = -1
    this.Thrombolytic_Decision_Making_to_AdminMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if (tdmtamd == Thrombolytic_Decision_Making_to_AdminMedianChartDateTemp.length - 1) {
        tdmtamd = -1
      }
      tdmtamd++
      return Thrombolytic_Decision_Making_to_AdminMedianChartDateTemp[tdmtamd];
    };

  }

  DTN30percentmeancalChartContent: any;
  DTN30percentmeancalChartContentTemp: any;
  DTN45percentmeancalChartContent: any;
  DTN45percentmeancalChartContentTemp: any;
  DTN60percentmeancalChartContent: any;
  DTN60percentmeancalChartContentTemp: any;

  DTN_30_45_60_Chart(DTN30MeanCalculations: any, DTN45MeanCalculations: any, DTN60MeanCalculations: any, Category: any) {
    let dtn30pm = -1;
    // this.DTN30percentmeancalChartContent = (e: SeriesLabelsContentArgs): string => {

    //   if(dtn30pm == this.DTN30percentmeancal.length - 1){
    //     dtn30pm = -1
    //   }
    //   dtn30pm++
    //   return this.DTN30percentmeancal[dtn30pm];
    // };
    // let dtn45pm = -1;
    // this.DTN45percentmeancalChartContent = (e: SeriesLabelsContentArgs): string => {
    //   if(dtn45pm == this.DTN45percentmeancal.length - 1){
    //     dtn45pm = -1
    //   }
    //   dtn45pm++
    //   return this.DTN45percentmeancal[dtn30pm];
    // };
    // let dtn60pm = -1;
    // this.DTN60percentmeancalChartContent = (e: SeriesLabelsContentArgs): string => {
    //   if(dtn60pm == this.DTN60percentmeancal.length - 1){
    //     dtn60pm = -1
    //   }
    //   dtn60pm++
    //   return this.DTN60percentmeancal[dtn30pm];
    // };
  }

  formatYAxisLabel(val: AxisLabelContentArgs): any {
    return ((new Date(val.value)).getHours() * 60 + (new Date(val.value)).getMinutes() + ':' + (new Date(val.value)).getSeconds());
  }

  exportToWordImproveTemplate() {
    this.sharedWordLoader = true;
    let improveFacilityTemplate: any = '';
    let quarter: any;
    let monthYear: any;

    let improveFacilityTableWord = JSON.parse(JSON.stringify(this.improveFacilityTable));
    let improveFacilityGraphsWord = JSON.parse(JSON.stringify(this.improveFacilityGraphs));
    let improveRapidiMOWord = JSON.parse(JSON.stringify(this.improveRapidiMO));
    let improveSummaryFacilityWord = JSON.parse(JSON.stringify(this.improveSummaryFacility));

    if (this.SelectedReportType == "monthly") {
      monthYear = this.monthYear;
    } else if (this.SelectedReportType == "quarterly") {
      switch (this.selectedQuarter) {
        case 'quarter1':
          quarter = 'Quarter 1'
          break;
        case 'quarter2':
          quarter = 'Quarter 2'
          break;
        case 'quarter3':
          quarter = 'Quarter 3'
          break;
        case 'quarter4':
          quarter = 'Quarter 4'
          break;
      }
      monthYear = `${quarter}, ${this.cumulativeYear}`
    }

    let wordTemplateData = `<div>
    <div style="display: block !important;
    margin-left: 150px !important;
    margin-right: 150px !important;"><img src="${this.src}" width="280" height="100" class="margin"></div>
    <p style="font-size:40px;  margin-top: 100px; margin-bottom: 70px; color: #633393; text-align: center;" ><b>TeleSpecialists <br>Quality Management <br>System</b><br></p>
    <p style="font-size:22px;  color: #ED2078; text-align:center;">${this.selectedOptionText}</p>
    <p style=" font-size: 22px; margin-top: 100px; color: #36286B; text-align:center;"><b>Stroke Service Line Quality Report, ${monthYear}<br>Facility Dashboard Report</b></p>`

    wordTemplateData += '<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>';

    improveFacilityTemplate = wordTemplateData + improveFacilityTableWord + improveFacilityGraphsWord + improveRapidiMOWord + improveSummaryFacilityWord;

    improveFacilityTemplate = improveFacilityTemplate.replace('<h2><b>Facility Dashboard Outliers Report</b></h2>', '');
    improveFacilityTemplate = improveFacilityTemplate.replace('</ul><h3><b>Notification to TS initial response (measure of TS response):</b></h3><ul>', '</ul><h3><b>Notification to TS initial response (measure of TS response):</b></h3><ul>');
    //  improveFacilityTemplate = improveFacilityTemplate.replace('<div class="content">','<br><br><br><br><br><br><br><br><br><br><br><br><br><br><div class="content">');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h2><b>RAPIDi Metric Outliers</b></h2>', '<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><h2 style="color:#36286B;font-size: 42px; margin-bottom: -10px;"><b>RAPIDi Metric Outliers</b></h2>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Activation Time Interval</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Activation Time Interval</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Assessment Time Interval</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Assessment Time Interval</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Thrombolytic Decision Time Interval</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Thrombolytic Decision Time Interval</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Thrombolytic Administration Time Interval</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Thrombolytic Administration Time Interval</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Activation (measure of hospital activation of TS):</b></h3>', '<br><br><br><br><br><h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Activation (measure of hospital activation of TS):</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Notification to TS initial response (measure of TS response):</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Notification to TS initial response (measure of TS response):</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Activation to Assessment (measure of teleneurology ability to assess the <br>patient after activation):</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Activation to Assessment (measure of teleneurology ability to assess the patient after activation):</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Assessment to Thrombolytic Decision (measure of teams ability to obtain critical information for <br>decision and physicians decision to administer thrombolytic after all information is obtained for <br>decision :</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Assessment to Thrombolytic Decision (measure of teams ability to obtain critical information for decision, and physicians decision to administer thrombolytic after all information is obtained for decision):</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Thrombolytic Decision to Administration (measure of speed of administration of thrombolytic by team after decision):</b></h3>', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Thrombolytic Decision to Administration (measure of speed of administration of thrombolytic by team after decision):</b></h3>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<h3><b>Summary of Opportunities for', '<h3 style="color:#ED2078;  font-size: 18px; margin-bottom: 10px;"><b>Summary of Opportunities for');
    improveFacilityTemplate = improveFacilityTemplate.replace('<div><h1 class="h-tag">GRAPHS</h1></div>', '<br style="page-break-before: always"><div><h1 style="color:#36286B;font-size: 42px; margin-bottom: -10px;">GRAPHS</h1></div>');
    improveFacilityTemplate = improveFacilityTemplate.replace('<label><b>Accomplishments/Improvements:</b>', '<br><br><br><label><b>Accomplishments/Improvements:</b>');


    let header =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Case Review</title><style>@@Page Section1{margin:0.70in 1in 0.70in 1in;} div.Section1 {page: Section1}</style></head><body>";
    let footer = '</body></html>';
    let sourceHTML = header + improveFacilityTemplate + footer;
    let source =
      'data:application/vnd.ms-word;charset=utf-8,' +
      encodeURIComponent(sourceHTML);
    let fileDownload = document.createElement('a');
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = 'ImproveTemplate.doc';
    fileDownload.click();
    document.body.removeChild(fileDownload);
    setTimeout(() => {
      this.sharedWordLoader = false;
    }, 500);
  }


  exportToPdfImproveTemplate() {
    let improveFacilityTemplate: any = '';
    improveFacilityTemplate = this.improveService._improvePiFilterObj.dataToDownloadPDF;
    const opt = {
      margin: [20, 20, 20, 20],
      filename: 'myfile.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, dpi: 192, letterRendering: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    html2pdf()
      .from(improveFacilityTemplate)
      .set(opt)
      .save();
  }
  // convertDataURIToBinary() {

  //   let raw = window.atob(btoa(this.editor._data));
  //   let rawLength = raw.length;
  //   let array = new Uint8Array(new ArrayBuffer(rawLength));

  //   for (let i = 0; i < rawLength; i++) {
  //     array[i] = raw.charCodeAt(i);
  //   }
  //   return array;
  // }

  closeTemplate() {
    this.generateTemplatebool = false;
    this.improveTemplate = '';
  }
  async exportPdf() {
    if (!this.chartFoundBool) {
      this.base64Image = [];
      let promises = [];
      let scale = 3;
      let htmlData1: any;
      let htmlData2: any;
      let htmlData3: any;
      let htmlData4: any;
      let htmlData5: any;
      let htmlData6: any;
      let htmlData7: any;
      let htmlData8: any;
      let htmlData9: any;
      let htmlData10: any;
      let htmlData11: any;
      let htmlData12: any;
      let htmlData13: any;
      for (let i = 1; i <= 13; i++) {
        let element: any = document.getElementById('htmlData' + i);
        let size = {
          width: element.clientWidth * scale,
          height: element.clientHeight * scale,
        };

        let promise = domtoimage.toPng(element, {
          width: size.width,
          height: size.height,
          style: {
            transform: 'scale(' + scale + ')',
            transformOrigin: 'top left'
          }
        })
          .then((blob: any) => {
            switch (i) {
              case 1: htmlData1 = blob; break;
              case 2: htmlData2 = blob; break;
              case 3: htmlData3 = blob; break;
              case 4: htmlData4 = blob; break;
              case 5: htmlData5 = blob; break;
              case 6: htmlData6 = blob; break;
              case 7: htmlData7 = blob; break;
              case 8: htmlData8 = blob; break;
              case 9: htmlData9 = blob; break;
              case 10: htmlData10 = blob; break;
              case 11: htmlData11 = blob; break;
              case 12: htmlData12 = blob; break;
              case 13: htmlData13 = blob; break;
            }

            if (htmlData1 && htmlData2 && htmlData3 && htmlData4 && htmlData5 && htmlData6 && htmlData7 && htmlData8 && htmlData9 && htmlData10 && htmlData11 && htmlData12 && htmlData13) {
              this.base64Image.push(htmlData1, htmlData2, htmlData3, htmlData4, htmlData5, htmlData6, htmlData7, htmlData8, htmlData9, htmlData10, htmlData11, htmlData12, htmlData13);
            }
            return `<img title="Dashboard All Charts" src="${blob}" width="700" height="400"><br>`;
          });

        promises.push(promise);
      }
      let images = await Promise.all(promises);

      this.improveFacilityGraphs = images.join('');
      this.showProgressSpinner = false;
      this.generateTemplateLoader = false;
      this. finalTemplateData = this.improveTemplate + this.improveSummaryFacility + this.improveRapidiMO + this.improveFacilityTable + this.improveFacilityGraphs
    }
    else {
      this.base64Image = [];
      this.showProgressSpinner = false;
      this.generateTemplateLoader = false;
    }
  }

  GetFacilityContact(event: any) {
    this.sharebtnLoader = true
    this.showProgressSpinner = true;
    let facilityVal: any = '';
    let systemVal: any = '';
    let regionalVal: any = '';
    if (this.selectedFilterType == 'facility') {
      facilityVal = this.selectFacilityPIOptions;
    } else if (this.selectedFilterType == 'system') {
      systemVal = this.selectFacilityPIOptions;
    } else if (this.selectedFilterType == 'regional') {
      regionalVal = this.selectFacilityPIOptions;
    }

    let model = {
      Facility: facilityVal,
      System: systemVal,
      Regional: regionalVal
    }
    this.subscription.push(
      this.improveService.GetUserByFacility(model).subscribe({
        next: (res: any) => {
          this.shareImprove = []
          res.data.forEach((value: any) => {
            let shareKeys: any = Object.keys(value);
            let sb: any = [];
            shareKeys.forEach((item: any, index: any) => {
              if ((item.includes('Name') && value[item] != null && !item.includes('fpigi_facility_Name'))) {
                sb.push({ [shareKeys[index]]: value[shareKeys[index]] });
                sb.push({ [shareKeys[index + 1]]: value[shareKeys[index + 1]] });
                sb.push({ [shareKeys[index + 2]]: value[shareKeys[index + 2]] });
              }
            });
            let myArr: any = [];
            let label: any;
            sb.forEach((element: any, index: any) => {
              if (index % 3 == 0) {
                myArr = sb.slice(index, index + 3)
                let obj = myArr.flatMap((d: any) => Object.values(d)[0]);
                label = Object.keys(myArr[0])[0].split('_');
                label.shift();
                label.pop();
                label = label.join(' ');
                label = label.replace(/\b\w/g, (l: any) => l.toUpperCase())
                this.shareImprove.push({ 'name': obj[0], 'phone': obj[1], 'email': obj[2], 'label': label });
              }
            });
          });
          this.shareImprove?.forEach((element: any) => {
            element['isSelected'] = false;
            switch (element.label) {
              case 'Primary AccountingManager':
                element.label = "Accounting Manager"
                break;
              case 'Primary Controller':
                element.label = "Controller"
                break;
              case 'Medical Records Deficiencies Contact':
                element.label = "MD.Records (Deficiencies) CP"
                break;
              case 'President Or Ceo':
                element.label = "President Or CEO"
                break;
            }
          });
          this.displayModal = true;
          this.showProgressSpinner = false;
          this.sharebtnLoader = false;
          this.masterSelected = undefined;
          this.checkedList = [];
        },
        error: (err: any) => {
        },
      })
    );
  }
  async SendEmail() {

    if (this.checkedList.length > 0) {
      this.showsharedProgressSpinner = true;
      this.showProgressSpinner = true;
      let base64EmailMat = await this.improveService._improveComponent.ReportTemplateComponent.pdfBase64EmailMaterial();
      let templateData_selected_facility: any = null;
      let templateData_selected_system: any = null;
      let templateData_selected_regional: any = null;
      if (this.selectedFilterType == 'facility') {
        templateData_selected_facility = this.selectedOptionText;
      } else if(this.selectedFilterType == 'system') {
        templateData_selected_system = this.selectedOptionText;
      } else {
        templateData_selected_regional = this.selectedOptionText;
      }
      this.ReportPageLoader.value = true;
      let emails: any = [];
      this.checkedList.forEach((element: any, index: any) => {
        emails[index] = element.email;
      });
      let usersEmail = emails.join();
      let obj = {
        templateData_to: usersEmail,
        templateData_qitsd_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
        templateData_qitsd_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
        templateData_qitsd_created_by_date: new Date(),
        templateData_selected_facility: templateData_selected_facility,
        templateData_selected_system: templateData_selected_system,
        templateData_selected_regional: templateData_selected_regional,
        templateData_selected_date: String(this.datePipe.transform(this.Month, 'MMM, yyyy')),
        templateData: btoa(base64EmailMat)
      }
      this.subscription.push(
        this.improveService.SendEmailImproveFacility(obj).subscribe({
          next: (res: any) => {
            if (res.msg == "Success") {
              this.showProgressSpinner = false;
              this.showsharedProgressSpinner = false;
              this.toastrNotificaion.customSuccess("Email Sent Successfully");
              this.reportPageBool = false
              this.ReportPageLoader.value = false;
              this.displayModal = false;
            }
          }
        })
      );
    }
    else {
      this.messageService.add({
        key: 'emailErr',
        severity: 'error',
        detail: `Please select at least one of the following.`
      });
    }

  }

  isAscending: boolean = false;
  field: any;
  fieldTemp: any;
  customSort(event: any) {
    if (this.fieldTemp != event.multiSortMeta[0].field) {
      this.isAscending = false;
    }
    this.fieldTemp = event.multiSortMeta[0].field;
    for (let i = 0; i < this.headerFacilityImprovefacilityList.length; i++) {
      if (event.multiSortMeta[0].field == this.headerFacilityImprovefacilityList[i]
      ) { this.field = i; break; }
    }
    event.data.sort((data1: any, data2: any) => {
      let value1: any;
      let value2: any;
      switch (this.field) {
        case 0: value1 = data1[0].quality; value2 = data2[0].quality; break;
        case 1: value1 = data1[0].data1; value2 = data2[0].data1; break;
        case 2: value1 = data1[0].data2; value2 = data2[0].data2; break;
        case 3: value1 = data1[0].data3; value2 = data2[0].data3; break;
        case 4: value1 = data1[0].cumlative1; value2 = data2[0].cumlative1; break;
        case 5: value1 = data1[0].cumlative2; value2 = data2[0].cumlative2; break;
        case 6: value1 = data1[0].goals3; value2 = data2[0].goals3; break;
      }
      let result = 0;

      if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2, undefined, { numeric: true });
      } else if (typeof value1 === 'number' && typeof value2 === 'number') {
        result = value1 - value2;
      } else if (typeof value1 === 'string' && typeof value2 === 'number') {
        result = 1;
      } else if (typeof value1 === 'number' && typeof value2 === 'string') {
        result = -1;

      }

      if (this.isAscending) { result = -result; }
      return result;
    });
    this.isAscending = !this.isAscending;
  }

  GetEmailImproveFacility(value: any) {
    if (value == 'btn') {
      this.sharedReportLoader = true;
    }
    let templateData_selected_facility: any = '';
    let templateData_selected_system: any = '';
    let templateData_selected_regional: any = '';
    if (this.selectedFilterType == 'facility') {
      templateData_selected_facility = this.selectedOptionText;
    } else if(this.selectedFilterType == 'system') {
      templateData_selected_system = this.selectedOptionText;
    } else {
      templateData_selected_regional = this.selectedOptionText;
    }
    this.showsharedProgressSpinner = true;
    let model = {
      Facility: templateData_selected_facility,
      System: templateData_selected_system,
      Regional: templateData_selected_regional,
      Take: this.take,
      Skip: this.skip
    }
    this.subscription.push(
      this.improveService.GetEmailImproveFacility(model).subscribe({
        next: (res: any) => {
          this.sharedReportLoader = false;
          this.showsharedProgressSpinner = false;
          this.facilityMailData = res.data;
          this.totalRecords = res?.data.length > 0 ? res?.data[0]?.TOTALRECORDS : 0;
          if (this.facilityMailData.length > 0) {
            this.facilityMailData.forEach((element: any) => {
              element.qitsd_created_by_date = this.datePipe.transform(element.qitsd_created_by_date, 'MM/dd/yyyy hh:mm:ss');
            });
            this.noRecordFoundBool = false;
          } else {
            this.noRecordFoundBool = true;
          }
          this.displayBasic2 = true;
        }
      })
    );
  }
  masterSelected: any;
  checkUncheckAll() {
    for (var i = 0; i < this.shareImprove.length; i++) {
      this.shareImprove[i].isSelected = this.masterSelected;
    }

    this.getCheckedItemList();
  }

  isAllSelected() {
    this.masterSelected = this.shareImprove.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }
  checkedList: any = [];
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.shareImprove.length; i++) {
      if (this.shareImprove[i].isSelected)
        this.checkedList.push(this.shareImprove[i]);
    }
    this.checkedList = this.checkedList;
  }

  getPdf(obj: any) {
    if (obj?.qitsd_attachment.includes('data:application/pdf;base64')) {
      const link = document.createElement("a");
      link.href = obj?.qitsd_attachment;
      link.download = 'ImproveTemplate.pdf'
      link.click();
    }
    else {
      let html = htmlToPdfmake(obj?.qitsd_attachment);
      const documentDefinition = { content: html };
      pdfMake.createPdf(documentDefinition).download('ImproveTemplate.pdf');
    }
  }

  DataTransfer(dataTransferText: any) {
    this.improveService._improvePiFilterObj.selectedOptionText = this.selectedOptionText;
    if (this.SelectedReportType == "monthly") {
      this.improveService._improvePiFilterObj.monthYear = this.monthYear;
    } else if (this.SelectedReportType == "quarterly") {
      let quarter: any;
      switch (this.selectedQuarter) {
        case 'quarter1':
          quarter = 'Quarter 1'
          break;
        case 'quarter2':
          quarter = 'Quarter 2'
          break;
        case 'quarter3':
          quarter = 'Quarter 3'
          break;
        case 'quarter4':
          quarter = 'Quarter 4'
          break;
      }
      this.improveService._improvePiFilterObj.monthYear = `${quarter}, ${this.cumulativeYear}`
    }

    this.improveService._improvePiFilterObj.headingSummaryOportunity = this.headingSummaryOportunity;
    this.improveService._improvePiFilterObj.improveAHAAHASFL = this.improveAHAAHASFL;
    this.improveService._improvePiFilterObj.improveAHAAHASFL2 = this.improveAHAAHASFL2;
    this.improveService._improvePiFilterObj.activationToNeedleArray = this.activationToNeedleArray;
    this.improveService._improvePiFilterObj.improveAData = this.improveAData;
    this.improveService._improvePiFilterObj.improveAAData = this.improveAAData;
    this.improveService._improvePiFilterObj.improveNData = this.improveNData;
    this.improveService._improvePiFilterObj.improveATData = this.improveATData;
    this.improveService._improvePiFilterObj.improveTAMHATS = this.improveTAMHATS;
    /*  Activation */
    // this.improveService._improvePiFilterObj.activationTimeListQualifyCountEMS = this.activationTimeListQualifyCountEMS;
    // this.improveService._improvePiFilterObj.activationTotalRecords = this.activationTotalRecords;
    // this.improveService._improvePiFilterObj.activationTgTotalRecords = this.activationTgTotalRecords;
    // this.improveService._improvePiFilterObj.activationEMSTotalRecords = this.activationEMSTotalRecords;
    // this.improveService._improvePiFilterObj.activationEMSTimeCasesMaximum = this.activationEMSTimeCasesMaximum;
    // this.improveService._improvePiFilterObj.activationTriageTimeCasesMaximum = this.activationTriageTimeCasesMaximum;
    // this.improveService._improvePiFilterObj.activationEMSTimeCasesMean = this.activationEMSTimeCasesMean;
    // this.improveService._improvePiFilterObj.activationTriageTotalRecords = this.activationTriageTotalRecords;
    // this.improveService._improvePiFilterObj.activationTriageTimeCasesMean = this.activationTriageTimeCasesMean;
    // this.improveService._improvePiFilterObj.activationEMSTimeCasesMedian = this.activationEMSTimeCasesMedian;
    // this.improveService._improvePiFilterObj.activationTriageTimeCasesMedian = this.activationTriageTimeCasesMedian;
    // this.improveService._improvePiFilterObj.activationTimeListQualifyCountTriage = this.activationTimeListQualifyCountTriage;
    // this.improveService._improvePiFilterObj.WorkFlowTypePercentage = this.WorkFlowTypePercentage;

    
    this.improveService._improvePiFilterObj.rapidiObj = {
      /*  Activation */
      activation: {
        activationTimeListQualifyCountEMS: this.activationTimeListQualifyCountEMS,
        activationTotalRecords: this.activationTotalRecords,
        activationTgTotalRecords: this.activationTgTotalRecords,
        activationEMSTotalRecords: this.activationEMSTotalRecords,
        activationEMSTimeCasesMaximum: this.activationEMSTimeCasesMaximum,
        activationTriageTimeCasesMaximum: this.activationTriageTimeCasesMaximum,
        activationEMSTimeCasesMean: this.activationEMSTimeCasesMean,
        activationTriageTotalRecords: this.activationTriageTotalRecords,
        activationTriageTimeCasesMean: this.activationTriageTimeCasesMean,
        activationEMSTimeCasesMedian: this.activationEMSTimeCasesMedian,
        activationTriageTimeCasesMedian: this.activationTriageTimeCasesMedian,
        activationTimeListQualifyCountTriage: this.activationTimeListQualifyCountTriage,
        WorkFlowTypePercentage: this.WorkFlowTypePercentage,
      },
      assessment: {
        assessmentTimeListQualifyCountEMS: this.assessmentTimeListQualifyCountEMS,
        assessmentTotalRecords: this.assessmentTotalRecords,
        assessmentTgTotalRecords: this.assessmentTgTotalRecords,
        assessmentEMSTotalRecords: this.assessmentEMSTotalRecords,
        assessmentEMSTimeCasesMaximum: this.assessmentEMSTimeCasesMaximum,
        assessmentEMSTimeCasesMean: this.assessmentEMSTimeCasesMean,
        assessmentEMSTimeCasesMedian: this.assessmentEMSTimeCasesMedian,
        assessmentTriageTotalRecords: this.assessmentTriageTotalRecords,
        assessmentTriageTimeCasesMaximum: this.assessmentTriageTimeCasesMaximum,
        assessmentTriageTimeCasesMean: this.assessmentTriageTimeCasesMean,
        assessmentTriageTimeCasesMedian: this.assessmentTriageTimeCasesMedian,
        assessmentTimeListQualifyCountTriage: this.assessmentTimeListQualifyCountTriage,
        assessmentTimeListQualifyCountInpatient: this.assessmentTimeListQualifyCountInpatient,
        assessmentTotalInpatientRecords: this.assessmentTotalInpatientRecords,
        assessmentInpatientTimeCasesMaximum: this.assessmentInpatientTimeCasesMaximum,
        assessmentInpatientTimeCasesMean: this.assessmentInpatientTimeCasesMean,
        assessmentInpatientTimeCasesMedian: this.assessmentInpatientTimeCasesMedian,
        assessmentTotalTriageRecords: this.assessmentTotalTriageRecords,
        assessmentTimeListQualifyCountEDOnset: this.assessmentTimeListQualifyCountEDOnset,
        assessmentTotalEDOnsetRecords: this.assessmentTotalEDOnsetRecords,
        assessmentEDOnsetTimeCasesMaximum: this.assessmentEDOnsetTimeCasesMaximum,
        assessmentEDOnsetTimeCasesMean: this.assessmentEDOnsetTimeCasesMean,
        assessmentEDOnsetTimeCasesMedian: this.assessmentEDOnsetTimeCasesMedian,
      },
      thrombolytic:{
        thrombolyticDecisionTimeListQualifyCountEMS: this.thrombolyticDecisionTimeListQualifyCountEMS,
        thrombolyticDecisionTotalRecords: this.thrombolyticDecisionTotalRecords,
        thrombolyticDecisionTgTotalRecords: this.thrombolyticDecisionTgTotalRecords,
        thrombolyticDecisionEMSTotalRecords: this.thrombolyticDecisionEMSTotalRecords,
        thrombolyticDecisionEMSTimeCasesMaximum: this.thrombolyticDecisionEMSTimeCasesMaximum,
        thrombolyticDecisionEMSTimeCasesMean: this.thrombolyticDecisionEMSTimeCasesMean,
        thrombolyticDecisionEMSTimeCasesMedian: this.thrombolyticDecisionEMSTimeCasesMedian,
        thrombolyticDecisionTriageTotalRecords: this.thrombolyticDecisionTriageTotalRecords,
        thrombolyticDecisionTriageTimeCasesMaximum: this.thrombolyticDecisionTriageTimeCasesMaximum,
        thrombolyticDecisionTriageTimeCasesMean: this.thrombolyticDecisionTriageTimeCasesMean,
        thrombolyticDecisionTriageTimeCasesMedian: this.thrombolyticDecisionTriageTimeCasesMedian,
        thrombolyticDecisionTimeListQualifyCountTriage: this.thrombolyticDecisionTimeListQualifyCountTriage,
        thrombolyticDecisionTimeListQualifyCountInpatient: this.thrombolyticDecisionTimeListQualifyCountInpatient,
        thrombolyticDecisionTotalInpatientRecords: this.thrombolyticDecisionTotalInpatientRecords,
        thrombolyticDecisionInpatientTimeCasesMaximum: this.thrombolyticDecisionInpatientTimeCasesMaximum,
        thrombolyticDecisionInpatientTimeCasesMean: this.thrombolyticDecisionInpatientTimeCasesMean,
        thrombolyticDecisionInpatientTimeCasesMedian: this.thrombolyticDecisionInpatientTimeCasesMedian,
        thrombolyticDecisionTotalTriageRecords: this.thrombolyticDecisionTotalTriageRecords,
        thrombolyticDecisionTimeListQualifyCountEDOnset: this.thrombolyticDecisionTimeListQualifyCountEDOnset,
        thrombolyticDecisionEDOnsetRecords: this.thrombolyticDecisionEDOnsetRecords,
        thrombolyticDecisionEDOnsetTimeCasesMaximum: this.thrombolyticDecisionEDOnsetTimeCasesMaximum,
        thrombolyticDecisionEDOnsetTimeCasesMean: this.thrombolyticDecisionEDOnsetTimeCasesMean,
        thrombolyticDecisionEDOnsetTimeCasesMedian: this.thrombolyticDecisionEDOnsetTimeCasesMedian,
      },
      thrombolyticAdministration:{
       thrombolyticAdministrationTimeListQualifyCountEMS : this.thrombolyticAdministrationTimeListQualifyCountEMS,
   thrombolyticAdministrationTotalRecords : this.thrombolyticAdministrationTotalRecords,
   thrombolyticAdministrationTgTotalRecords : this.thrombolyticAdministrationTgTotalRecords,
   thrombolyticAdministrationEMSTotalRecords : this.thrombolyticAdministrationEMSTotalRecords,
   thrombolyticAdministrationEMSTimeCasesMaximum : this.thrombolyticAdministrationEMSTimeCasesMaximum,
   thrombolyticAdministrationEMSTimeCasesMean : this.thrombolyticAdministrationEMSTimeCasesMean,
   thrombolyticAdministrationEMSCasesMedian : this.thrombolyticAdministrationEMSCasesMedian,
   thrombolyticAdministrationTriageTotalRecords : this.thrombolyticAdministrationTriageTotalRecords,
   thrombolyticAdministrationTriageTimeCasesMaximum : this.thrombolyticAdministrationTriageTimeCasesMaximum,
   thrombolyticAdministrationTriageTimeCasesMean : this.thrombolyticAdministrationTriageTimeCasesMean,
   thrombolyticAdministrationTriageTimeCasesMedian : this.thrombolyticAdministrationTriageTimeCasesMedian,
   thrombolyticAdministrationTimeListQualifyCountTriage : this.thrombolyticAdministrationTimeListQualifyCountTriage,
   thrombolyticAdministrationTimeListQualifyCountInpatient : this.thrombolyticAdministrationTimeListQualifyCountInpatient,
   thrombolyticAdministrationTotalInpatientRecords : this.thrombolyticAdministrationTotalInpatientRecords,
   thrombolyticAdministrationInpatientTimeCasesMaximum : this.thrombolyticAdministrationInpatientTimeCasesMaximum,
   thrombolyticAdministrationInpatientTimeCasesMean : this.thrombolyticAdministrationInpatientTimeCasesMean,
   thrombolyticAdministrationInpatientTimeCasesMedian : this.thrombolyticAdministrationInpatientTimeCasesMedian,
   thrombolyticAdministrationTotalTriageRecords : this.thrombolyticAdministrationTotalTriageRecords,
   thrombolyticAdministrationTimeListQualifyCountEDOnset : this.thrombolyticAdministrationTimeListQualifyCountEDOnset,
   thrombolyticAdministrationTotalEDOnsetRecords : this.thrombolyticAdministrationTotalEDOnsetRecords,
   thrombolyticAdministrationEDOnsetTimeCasesMaximum : this.thrombolyticAdministrationEDOnsetTimeCasesMaximum,
   thrombolyticAdministrationEDOnsetTimeCasesMean : this.thrombolyticAdministrationEDOnsetTimeCasesMean,
   thrombolyticAdministrationEDOnsetTimeCasesMedian : this.thrombolyticAdministrationEDOnsetTimeCasesMedian,
      }
    }
    
    this.improveService._improvePiFilterObj.reportDataObject = this.bodyFacilityImprovefacilityList;
    this.improveService._improvePiFilterObj.reportHeaderObject = this.headerFacilityImprovefacilityList;

    this.improveService._improvePiFilterObj.cumulativeYear = this.cumulativeYear;
    this.improveService._improvePiFilterObj.pastcumulativeYear = this.pastcumulativeYear;
    this.improveService._improvePiFilterObj.qti_accomplishments_improvements = this.qti_accomplishments_improvements;
    this.improveService._improvePiFilterObj.qti_opportunities_pi_projects = this.qti_opportunities_pi_projects;
    this.improveService._improvePiFilterObj.graphImages = this.base64Image;
    this.improveService._improvePiFilterObj.selectedFilterType = this.selectedFilterType;
    this.improveService._improvePiFilterObj.quarterYearForLabel = this.quarterYearForLabel;
    this.improveService._improvePiFilterObj.quarterYearForPreviousLabel = this.quarterYearForPreviousLabel;
    this.improveService._improvePiFilterObj.selectedQuarter = this.selectedQuarter;
    this.improveService._improvePiFilterObj.monthYearForLabel = this.monthYearForLabel;
    this.improveService._improvePiFilterObj.sMonth = this.sMonth;
    this.improveService._improvePiFilterObj.monthYearForPreviousLabel = this.monthYearForPreviousLabel;
    this.improveService._improvePiFilterObj.chartFoundBool = this.chartFoundBool;
    this.improveService._improvePiFilterObj.IsEmsOrInPatientBoolNewObj = this.IsEmsOrInPatientBoolNewObj;

    this.labelReportPage = dataTransferText;
    if (dataTransferText.includes('Email')) {
      if (this.checkedList.length > 0) {
        this.reportPageBool = true;
      }
      else {
        this.messageService.add({
          key: 'emailErr',
          severity: 'error',
          detail: `Please select at least one of the following.`
        });
      }
    } else {
      this.reportPageBool = true;
    }

  }

  exportToPdf() {
    this.ReportPageLoader.value = true;
    this.improveService._improveComponent.ReportTemplateComponent.exportPdf(this.ReportPageLoader);
  }

  exportToWord() {
    this.improveService._improveComponent.ReportTemplateComponent.exportWord();
  }

  calculateRotation() {
    let numLabels = this.doortostartMeanChart.length;

    let rotation = 0;
    if (numLabels > 10 && this.screenWidth < 1300) {
      rotation = -50;
    } else if (numLabels > 10 && this.screenWidth > 1300) {
      rotation = -30;
    } else {
      rotation = 0
    }
    return rotation;
  }

  calculateLengthForMarginLabel() {
    let numLabels = this.doortostartMeanChart.length;
    let margin = 0;
    if (numLabels > 12 && this.screenWidth > 1300) {
      margin = 35;
    } else if (numLabels > 12 && this.screenWidth < 1300) {
      margin = 20
    } else if (numLabels <= 12 && this.screenWidth > 1300) {
      margin = 25;
    } else if (numLabels >= 12 && this.screenWidth < 1300) {
      margin = 15
    } else {
      margin = 30
    }
    return margin;
  }

  loadfacilityMailData(event: any) {

    if (event != undefined && this.selectedOptionText != "") {
      this.showsharedProgressSpinner = true;
      this.take = event.rows;
      this.pageNumber = (event.first / this.take) + 1;
      this.skip = this.take * this.pageNumber - this.take;
      this.sortOrder = (event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1) ? 'ASC' : 'DESC';
      this.sortCol = (event.multiSortMeta == undefined) ? '' : event.multiSortMeta[0].field;
      this.filterVal = event.filters.global == undefined ? '' : event.filters.global.value;
      this.GetEmailImproveFacility('');
    }
  }

  ngOnDestroy() {
    if (this.subscription.length != 0) {
      this.subscription.forEach((i: any) => {
        i.unsubscribe();
      })
    }

    Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);
  }

  onTextareaChange(event: any, type: any) {
    let val = (event.target as HTMLInputElement).value;

    if (
      this.qti_accomplishments_improvements === '' && this.qti_accomplishments_improvements_temp === '' &&
      this.qti_opportunities_pi_projects === '' && this.qti_opportunities_pi_projects_temp === '' 
    ) {
      this.isChangeTextBox = true;
    } else {
      this.isChangeTextBox = false;
    }
  }
  
  

getStyle(subBodyFacilityList: any, type: string) {
    const style:any = {};
    if(type == 'data1'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data1R < subBodyFacilityList.goals1R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data1R > subBodyFacilityList.goals1R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
      if (this.stylesForData1.length === 21) {
        style['color'] = 'white';
        style['background'] = '#969696';
      }
    }else if(type == 'data2'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data2R < subBodyFacilityList.goals2R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data2R > subBodyFacilityList.goals2R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
      if (this.stylesForData2.length === 21) {
        style['color'] = 'white';
        style['background'] = '#969696';
      }
    }else if(type == 'data3'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data3R < subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data3R > subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
      if (this.stylesForData3.length === 21) {
        style['color'] = 'white';
        style['background'] = '#969696';
      }
    }else if(type == 'data4'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.cumlative1R < subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.cumlative1R > subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
    }
 
    if(type === 'data1' && this.stylesForData1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data1 === '0' || subBodyFacilityList?.data1 === '')){
      this.administratedCheckData1Bool = true;
    }
    else if(type === 'data2' && this.stylesForData2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data2 === '0' || subBodyFacilityList?.data2 === '')){
      this.administratedCheckData2Bool = true;
    }
    else if(type === 'data3' && this.stylesForData3.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data3 === '0' || subBodyFacilityList?.data3 === '')){
      this.administratedCheckData3Bool = true;
    }
    else if(type === 'data4' && this.stylesForCumlative1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.cumlative1 === '0' || subBodyFacilityList?.cumlative1 === '')){
      this.administratedCheckComulative1Bool = true;
    }
    else if(type === 'data5' && this.stylesForCumlative2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.cumlative2 === '0' || subBodyFacilityList?.cumlative2 === '')){
      this.administratedCheckComulative2Bool = true;
    }

    if(type === 'data1' && this.stylesForData1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data1 !== '0' || subBodyFacilityList?.data1 !== '')){
      this.IsEmsOrInPatData1Bool = true;
    }
    else if(type === 'data2' && this.stylesForData2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data2 !== '0' || subBodyFacilityList?.data2 !== '')){
      this.IsEmsOrInPatData2Bool = true;
    }
    else if(type === 'data3' && this.stylesForData3.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data3 !== '0' || subBodyFacilityList?.data3 !== '')){
      this.IsEmsOrInPatData3Bool = true;
    }
    else if(type === 'data4' && this.stylesForCumlative1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.cumlative1 !== '0' || subBodyFacilityList?.cumlative1 !== '')){
      this.IsEmsOrInPatComulative1Bool = true;
    }
    else if(type === 'data5' && this.stylesForCumlative2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.cumlative2 !== '0' || subBodyFacilityList?.cumlative2 !== '')){
      this.IsEmsOrInPatComulative2Bool = true;
    }
    if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
    subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
    subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
    subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
    subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
    this.administratedCheckData1Bool && type === 'data1'){
      style['color'] = 'white';
      style['background'] = '#969696';
      }

      if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
      subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
      this.administratedCheckData2Bool && type === 'data2'){
        style['color'] = 'white';
        style['background'] = '#969696';
        }

        if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
        subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
        subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
        this.administratedCheckData3Bool && type === 'data3'){
          style['color'] = 'white';
          style['background'] = '#969696';
          }

      if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
      subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
      this.administratedCheckComulative1Bool && type === 'data4'){
        style['color'] = 'white';
        style['background'] = '#969696';
        }
        

      if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
      subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
      this.administratedCheckComulative2Bool && type === 'data5'){
        style['color'] = 'white';
        style['background'] = '#969696';
        }

  if ((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
    subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
    subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') &&
    ((this.IsEmsOrInPatientBoolNewObj[1] == "False" && type === 'data1' && this.IsEmsOrInPatData1Bool) ||
     (this.IsEmsOrInPatientBoolNewObj[2] == "False" && type === 'data2' && this.IsEmsOrInPatData2Bool) ||
     (this.IsEmsOrInPatientBoolNewObj[3] == "False" && type === 'data3' && this.IsEmsOrInPatData3Bool) ||
     (this.IsEmsOrInPatientBoolNewObj[4] == "False" && type === 'data4' && this.IsEmsOrInPatComulative1Bool) ||
     (this.IsEmsOrInPatientBoolNewObj[5] == "False" && type === 'data5' && this.IsEmsOrInPatComulative2Bool))
    ) {
    style['color'] = 'white';
    style['background'] = '#969696';
  }
    return style;
  }

}